
if (typeof gsap !== 'undefined') {
if (typeof ScrollTrigger !== 'undefined') {
gsap.registerPlugin(ScrollTrigger);
// Mobile Safari fires `resize` every time the URL bar collapses, and
// ScrollTrigger's default response is a full refresh — re-measuring every
// trigger mid-scroll, which shows up as the parallax and reveals nudging a
// few px the first time you scroll on an iPhone. This is GSAP's own switch
// for exactly that.
ScrollTrigger.config({ ignoreMobileResize: true });
}
gsap.config({ nullTargetWarn: false });
}
// Run fn now if the DOM is already parsed, else on DOMContentLoaded. Footer
// embeds normally run before DCL, but this also survives async/late injection.
function pulseReady(fn) {
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
else fn();
}
// One frame, as a promise. Used right before measuring layout (ScrollTrigger
// positions, parallax) so a just-finished DOM mutation (Webflow.destroy()/
// ready() in beforeEnter, in particular) has had one full layout/paint pass
// to settle before anything reads offsets from it.
function pulseNextFrame() {
return new Promise(function (res) { requestAnimationFrame(function () { res(); }); });
}
// ScrollTrigger positions are measured from layout — but images and web fonts
// land AFTER first paint and shift everything, so triggers created now would
// fire at the wrong scroll positions. Refresh once the page fully loads and
// again when fonts settle. Debounced so overlapping signals collapse into one.
var _pulseRefreshT = null;
function pulseRefresh() {
if (typeof ScrollTrigger === 'undefined') return;
if (_pulseRefreshT) clearTimeout(_pulseRefreshT);
_pulseRefreshT = setTimeout(function () { ScrollTrigger.refresh(); }, 60);
}
window.addEventListener('load', pulseRefresh);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(pulseRefresh);
// LAZY-LOADED IMAGES. Webflow ships images with loading="lazy", so they land as
// you scroll — long after `load` fired. Each one that arrives without reserved
// space changes the document height and silently invalidates every ScrollTrigger
// position measured below it, which is why reveals drift further down the page
// and fire at the wrong moment. Re-measure whenever one lands. pulseRefresh is
// debounced, so a burst of images collapses into a single refresh.
// A parallax wrap's geometry depends on its media having decoded: an undecoded
// image leaves the wrap collapsed, and the fill's "doesn't fill -> go absolute"
// correction is gated on the wrap measuring more than 4px, so it gets skipped and
// never revisited. Re-run the parallax (debounced) when an image inside one lands,
// so a late image heals its own layout.
var _pulseParallaxHealT = null;
function pulseHealParallax() {
if (typeof window.initParallax !== 'function') return;
clearTimeout(_pulseParallaxHealT);
_pulseParallaxHealT = setTimeout(function () { window.initParallax(); }, 120);
}
function pulseWatchImages(root) {
var imgs = (root || document).querySelectorAll('img');
Array.prototype.forEach.call(imgs, function (img) {
if (img._pulseWatched) return;
img._pulseWatched = true;
if (img.complete) return;                     // already decoded — nothing to wait for
var inParallax = !!(img.closest && img.closest('.parallax_wrap'));
var onSettled = inParallax
? function () { pulseRefresh(); pulseHealParallax(); }
: pulseRefresh;
img.addEventListener('load',  onSettled, { once: true });
img.addEventListener('error', onSettled, { once: true });
});
}
// True only on devices that genuinely hover with a fine pointer (mouse/trackpad).
// Touchscreens report (hover: none) — we skip hover-driven behavior there so a
// single tap navigates instead of the first tap being eaten by a hover swap.
function pulseCanHover() {
return !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
function pulseOnResize(fn, delay) {
var lastW = window.innerWidth, t;
window.addEventListener('resize', function () {
if (window.innerWidth === lastW) return;   // toolbar-only: not a real resize
lastW = window.innerWidth;
if (!delay) return fn();
clearTimeout(t);
t = setTimeout(fn, delay);
});
}
// Barba page transitions — a dip to white (out, fully white, back in). ON.
// Links do an SPA swap behind the white veil; the menu, reveals, parallax, and
// nav all re-init per page in after(). The previous "buggy first click" was ix2
// loading the prior page's interactions because <html data-wf-page> was never
// updated on swap — now fixed in after() via pulseSyncWfPage(). Flip to false
// for plain full-page loads (nothing else needs to change).
var PULSE_PAGE_TRANSITIONS = true;
// The centre mask is ALWAYS mask + scale: whatever is masking in also settles from
// this much zoom back to 1. One value so the hero/nav swap, the nav menu, the intro
// images and the global image reveal all share the exact same gesture.
var PULSE_MASK_ZOOM = 0.25;
var PULSE_MOTION = {
// The shared mask ease. Drives the swap, the menu, the page transitions, and
// (by default) the reveals below. `expo.out` starts fast and decelerates into
// rest — the mask flies open and settles, rather than easing in AND out
// (`expo.inOut`), which reads slower and more symmetrical at both ends.
ease: 'power4.inOut',
// THE centre-mask duration (seconds) — one knob for every centre mask on the
// site: the hero + nav swap, the nav menu, the intro images and the global
// [data-anim="image"] reveal all derive from it. Change this and they all move
// together. Individual surfaces can still override (see maskCloseRatio below,
// and HERO_SWAP_DUR in the hero script).
maskDuration: 0.65,
// The close/exit is a fraction of that — closing reads better slightly quicker.
maskCloseRatio: 0.65,
// Scroll reveals ([data-anim] images + text) play ONCE and stay — an element
// masks/fades in as it scrolls up and is then left revealed for good. Set true
// to re-arm each reveal once it drops fully below the fold so it replays on the
// next pass (the old looping behaviour — see pulseArmOnExit).
replayReveals: false,
// Global IMAGE reveal — any element tagged [data-anim="image"] masks in on
// scroll in the SAME language as everything else: a band opening from the
// centre outward, with a subtle inner settle. Wrap the <img> (or a
// background-image div) and tag the wrapper.
image: {
duration: 1.00,      // null → inherit PULSE_MOTION.maskDuration
ease: 'expo.inOut',  // null → inherit PULSE_MOTION.ease
from: 'center',      // 'center' (default language) | 'top' | 'bottom' | 'left' | 'right'
scaleFrom: 1 + PULSE_MASK_ZOOM,   // inner settle, shared with every other mask (1 = off)
// ScrollTrigger start, read as "<element edge> <viewport edge>": fire when the
// element's CENTRE reaches the BOTTOM of the viewport — i.e. the moment it is
// half in view. 'center bottom' fires EARLIER than the old 'center 85%'
// (bottom = 100% of the viewport, 85% is higher up), which also gives
// near-the-end content more room to trigger before the page runs out of
// scroll. Deliberately NOT clamped — see the note above pulseArmOnExit.
start: 'center bottom',
},
// Global TEXT reveal — word-by-word FADE (opacity), staggered. TEMP: a neutral
// placeholder while the client decides the motion language. To switch back to a
// clip wipe later, restore the clip version of pulseRevealText (see git
// history) and give this block a `from` direction again. Split is manual.
text: {
duration: 1.00,
ease: 'power2.out',  // soft fade-in (deliberately NOT the wipe ease)
stagger: 0.050,
// Cap the TOTAL word-stagger spread. Without this, stagger * wordCount runs
// away on long paragraphs — 0.05 x 100 words = 5s, "way too long". GSAP's
// `amount` distributes a fixed total across however many words there are, so
// the whole reveal always finishes within maxStagger + duration.
maxStagger: 1.0,     // seconds — longest the word cascade may take
// Optional escape hatch: above this many words, skip the per-word split and
// fade the whole element as one soft fade. 0 (default) DISABLES it, so long
// body copy uses the very same word cascade as titles — identical duration
// and stagger, just bounded in total by maxStagger. Set a positive N only if
// you want very long copy to flat-fade instead.
wordCap: 0,
yPercent: 0,         // pure fade; bump (e.g. 20) for a subtle fade-UP
start: 'center bottom',   // same trigger point as images
},
letters: {
duration: 0.90,
ease: 'expo.out',    // arrives fast, settles — the letters should not drift
stagger: 0.030,      // matches NAV_LETTER_STAGGER
maxStagger: 1.2,     // total spread ceiling, same reasoning as text.maxStagger
fromYPercent: 118,
delay: null,
heroPages: ['/about', '/brand-partnerships'],
start: 'center bottom',   // same trigger point as images and words
},
};
// Resolve an effect-local ease/duration against the shared defaults. These are
// FUNCTIONS, called at animation time rather than read once at boot — that's what
// lets the motion panel (and ?ease= / ?dur=) retune the site live.
function pulseEase(local) { return local || PULSE_MOTION.ease; }
function pulseMaskD(local) { return local != null ? local : PULSE_MOTION.maskDuration; }
function pulseMaskCloseD() { return PULSE_MOTION.maskDuration * PULSE_MOTION.maskCloseRatio; }
// The centre band (fully closed) and the fully-open mask. These two values ARE the
// motion language — the intro images, the nav menu, the hero/nav swap and the
// global [data-anim="image"] reveal all animate between them.
var PULSE_MASK_CLOSED = 'inset(50% 0% 50% 0%)';
var PULSE_WIPE_OPEN   = 'inset(0% 0% 0% 0%)';
// Start clip-path inset for a mask coming FROM `edge`. inset(top right bottom
// left). 'center' — the site's default language — collapses BOTH the top and
// bottom to 50%, so the layer starts as a band on the horizontal centre line and
// opens outward. The edge values instead collapse the OPPOSITE side to 100%, so
// the layer starts as a sliver on `edge` and grows across. End is always the
// fully-open inset(0 0 0 0).
function pulseMirrorEase(name) {
if (!name || name === 'none') return name;
if (/\.inOut$/.test(name)) return name;
if (/\.out$/.test(name))   return name.replace(/\.out$/, '.in');
if (/\.in$/.test(name))    return name.replace(/\.in$/, '.out');
return name + '.in';
}
function pulseWipeFromInset(edge) {
switch (edge) {
case 'right':  return 'inset(0% 0% 0% 100%)';
case 'top':    return 'inset(0% 0% 100% 0%)';
case 'bottom': return 'inset(100% 0% 0% 0%)';
case 'left':   return 'inset(0% 100% 0% 0%)';
// 'center-x' is the centre band rotated: a VERTICAL sliver on the middle
// column that opens left+right, where 'center' is a horizontal sliver that
// opens up+down.
case 'center-x': return 'inset(0% 50% 0% 50%)';
case 'center':
default:       return PULSE_MASK_CLOSED;
}
}
(function (global) {
const _controllers = [];
// Hard ceiling for stacked-layer z-indexes. Must stay well below any site
// chrome (the nav is z-index 100) so a slide can never out-stack it.
const STACK_Z_CEIL = 20;
if (typeof gsap === 'undefined') {
console.warn('[PulseSwap] GSAP not found — load gsap.min.js before this script.');
return;
}
function createSwapController(opts) {
const items = Array.from(opts.items || []);
const inner = opts.inner ? Array.from(opts.inner) : items;
const currentClass = opts.currentClass || 'is-current';
// Whether THIS controller applies the mask's scale to its inner images.
// The hero opts out (innerZoom:false) because its scroll response already
// owns `scale` on those same elements, written every frame from a ticker —
// two writers on one transform property would fight and the last write each
// frame would win. The hero supplies the mask's scale itself instead, in
// lockstep with the swap. Everything else (the nav previews) leaves it on.
const innerZoom = opts.innerZoom !== false;
// Stack mode: masks are allowed to OVERLAP. Each new one opens on top of
// whatever is already there instead of waiting for the previous to finish.
//   stack: false  (default) one at a time; a request mid-transition is queued
//   stack: true             unbounded — pile up as many as you can trigger
//   stack: <number>         bounded — at most N masks open at once
// Bounding does NOT drop input (that's what made it feel gated). When the cap
// is reached the OLDEST mask is sped up so it finishes and frees a slot —
// it's underneath the newer ones, so accelerating it reads as depth settling
// rather than a cut. Snapping it to its end instead would pop.
const stack = opts.stack === true || typeof opts.stack === 'number';
const maxStack = typeof opts.stack === 'number' ? Math.max(1, opts.stack) : Infinity;
const running = [];   // [{ tl, el }] oldest → newest
// Monotonic identity token — used ONLY to tell which mask is newest. It is
// deliberately NOT the z-index (see the re-pack in goTo).
let seq = 0;
if (!items.length) {
console.warn('[PulseSwap] No items provided.');
return null;
}
const CFG = {
// 'mask' (the site's centre-mask language) | 'push' | 'flip' (directional,
// hero-only — see the effect branch in goTo).
effect: opts.effect || 'mask',
ease: opts.ease || null,   // null = inherit PULSE_MOTION.ease (the IN / arrival ease)
// Separate ease for the OUT (closing) half of a swap. null = derive it from
// the IN ease by mirroring (expo.out → expo.in), which is the long-standing
// behaviour that keeps a closing mask from slamming shut. Set a value to give
// the exit its OWN curve, independent of the arrival — used VERBATIM (not
// mirrored), so what you pick is exactly what the close plays.
outEase: opts.outEase || null,
// Which edge the mask travels FROM, and whether the INCOMING layer opens
// over the top ('in') or the OUTGOING layer closes away to reveal what's
// underneath ('out'). Only used by the 'mask' effect.
maskFrom: opts.maskFrom || 'center',
maskMode: opts.maskMode || 'in',
// 'in' mode only: also close the OUTGOING layer, so a change is masked at
// both ends instead of the old slide popping out. See the cross-mask block.
maskOutgoing: opts.maskOutgoing === true,
// Give the mask 'push'-like travel: the INNER image slides out of the
// opening band while the outgoing layer drifts the other way. maskSlideAmt
// is a percentage of the slide's own height.
maskSlide: opts.maskSlide !== false,
maskSlideAmt: opts.maskSlideAmt != null ? opts.maskSlideAmt : 15,
// 'sequence' effect: how far the OUTGOING image scales down as it masks
// away, what fraction of the duration that first phase gets, and how much
// the second phase overlaps it (so the two bands cross at the centre line
// instead of leaving a dead beat).
seqOutScale: opts.seqOutScale != null ? opts.seqOutScale : 0.6,
// Start scale of the INCOMING inner image. push gets most of its depth
// from 1.5 here — the centre mask's own 1.06 settle is far too polite to
// read as parallax, which is why 'mask' felt flat next to it.
inScale: opts.inScale != null ? opts.inScale : 1.35,
zBase: opts.zBase || 0,
zCeil: opts.zCeil != null ? opts.zCeil : STACK_Z_CEIL,
maskOut: opts.maskOut !== false,
maskOutDir: !!opts.maskOutDir,
scrimEl: opts.scrimEl || null,
scrimOn: !!opts.scrimOn,
scrimOpacity: opts.scrimOpacity != null ? opts.scrimOpacity : 0.35,
outRatio: opts.outRatio != null ? opts.outRatio : 0.6,
inDelayRatio: opts.inDelayRatio != null ? opts.inDelayRatio : 0.35,
inRatio: opts.inRatio != null ? opts.inRatio : 0.65,
duration: opts.duration != null ? opts.duration : PULSE_MOTION.maskDuration,
};
let cur = opts.initialIndex || 0;
let busy = false;
let pending = null;  // latest target requested while a swap is mid-flight
items.forEach((el, i) => el.classList.toggle(currentClass, i === cur));
function goTo(nextIdx, direction) {
if (!items[nextIdx]) return;
// NON-stacking (the default, e.g. the nav previews): one mask at a time, and
// a request that lands mid-transition is remembered rather than dropped.
if (!stack && busy) { pending = { idx: nextIdx, direction: direction }; return; }
if (nextIdx === cur) return;
const prev = cur;
const d = CFG.duration;
const ease = pulseEase(CFG.ease);
// The exit ease. An explicit outEase is honoured verbatim; otherwise fall
// back to the mirror of the IN ease (a closing mask driven by an `.out`
// ease slams shut, so the default reverses it). Every OUT/close tween in
// every effect routes through this.
const closeEase = CFG.outEase ? pulseEase(CFG.outEase) : pulseMirrorEase(ease);
// Advance the pointer IMMEDIATELY. In stack mode this is what lets a fast
// scroll walk 0→1→2→3 rather than re-requesting the same slide each time.
cur = nextIdx;
busy = true;
const currentEl = items[prev];
const currentInner = inner[prev];
const effect = CFG.effect;
const upcomingEl = items[nextIdx];
const upcomingInner = inner[nextIdx];
// This slide may still be mid-mask from an earlier trip around the loop.
gsap.killTweensOf([upcomingEl, upcomingInner].filter(Boolean));
const token = ++seq;
// Enforce the cap: hurry the oldest mask(s) along rather than refusing input.
while (stack && running.length >= maxStack) {
const oldest = running.shift();
if (oldest && oldest.tl.isActive()) oldest.tl.timeScale(6);
}
// Re-pack the live layers into a SMALL fixed range (1..n) instead of letting
// z climb forever. An ever-increasing z-index eventually passes the site
// chrome — the nav sits at z-index 100, so after enough slide changes the
// hero rendered ON TOP of the nav for the length of a swap, then dropped
// back when the swap cleared the property. Only relative order matters
// between slides, so a low range is sufficient and can never escape.
running.forEach(function (e, i) { gsap.set(e.el, { zIndex: CFG.zBase + i + 1 }); });
const z = CFG.zBase + Math.min(running.length + 1, CFG.zCeil);
const tl = gsap.timeline({
onStart() { upcomingEl.classList.add(currentClass); },
onComplete() {
const at = running.findIndex(function (e) { return e.tl === tl; });
if (at !== -1) running.splice(at, 1);
// In stack mode only the NEWEST mask tidies up. An older one finishing
// must not strip layers a newer mask is still opening over — without
// this guard, a fast scroll would flicker as stale masks cleaned house.
if (stack && token !== seq) return;
// Elements still mid-flight in another timeline must be left alone —
// clearing their clip/transform here strips the mask off a layer that
// is actively animating, which shows as an unmasked image that just
// scales. Only tidy up layers that are genuinely finished.
const stillRunning = running.map(function (e) { return e.el; });
items.forEach(function (it, i) {
if (i === cur) return;
if (stillRunning.indexOf(it) !== -1) return;
gsap.killTweensOf([it, inner[i]].filter(Boolean));
it.classList.remove(currentClass);
gsap.set([it, inner[i]].filter(Boolean), { clearProps: 'transform,opacity,clipPath,zIndex' });
});
gsap.set([upcomingEl, upcomingInner].filter(Boolean), { clearProps: 'transform,opacity,clipPath,zIndex' });
upcomingEl.classList.add(currentClass);
busy = false;
if (!stack && pending && pending.idx !== cur) {
const p = pending; pending = null;
goTo(p.idx, p.direction);
} else {
pending = null;
}
}
});
running.push({ tl: tl, el: upcomingEl });
// Seamless single-layer MASK-FROM-CENTRE. Whatever is already on screen stays
// fully painted UNDERNEATH; the upcoming image sits on top and opens from a
// band on the horizontal centre line outward. Because the layer below covers
// the whole area the entire time, no background can ever show through a seam.
// All clip values are in % (consistent units) so GSAP interpolates instead of
// snapping ("pop").
//
// The site's one motion language, shared with the intro images, the nav menu
// and the global [data-anim="image"] reveal. Deliberately NON-directional:
// next and prev look identical, because a centre mask has no direction.
//
// STACK MODE: we deliberately do NOT touch the outgoing layer. It keeps its
// own z-index and, if its own mask is still opening, keeps right on opening
// underneath — that layering is the whole effect. Forcing it to a fixed
// z/clip here would snap the previous mask shut and there'd be nothing to
// stack. In non-stack mode there is only ever one mask, so we pin the pair.
const dirSign = (direction === 'prev') ? -1 : 1;
// Exit mask edge: directional collapses the way you scrolled (next -> to the
// top, prev -> to the bottom) so the old image leaves alongside the new one
// arriving; otherwise the centre band.
const outClosed = CFG.maskOutDir
? pulseWipeFromInset(direction === 'prev' ? 'bottom' : 'top')
: pulseWipeFromInset('center');
const outOnTop = CFG.maskOut;
const zOut = CFG.zBase + (outOnTop ? 10 : 1);
const zIn  = CFG.zBase + (outOnTop ? 1 : 10);
// Fade the scrim up across the exit and back down across the entry, so it
// is darkest exactly when the least image is on screen.
function addScrim(outDur, inAt, inDur) {
if (!CFG.scrimOn || !CFG.scrimEl) return;
tl.fromTo(CFG.scrimEl, { opacity: 0 },
{ opacity: CFG.scrimOpacity, duration: outDur, ease: ease }, 0)
.to(CFG.scrimEl, { opacity: 0, duration: inDur, ease: ease }, inAt);
}
if (effect === 'push' || effect === 'flip') {
const inEl = upcomingInner || upcomingEl;
// Directional effects translate a full viewport height, so any clip must
// be open or the slide would be masked while it travels.
tl.set(upcomingEl, { clipPath: PULSE_WIPE_OPEN, opacity: 1, zIndex: CFG.zBase + 10 }, 0)
.set(currentEl, { zIndex: CFG.zBase + 1 }, 0);
items.forEach(function (other) {
if (other !== currentEl && other !== upcomingEl) tl.set(other, { opacity: 0 }, 0);
});
if (effect === 'push') {
tl.to(currentEl, { scale: 0.4, duration: d, ease: 'power2.inOut' }, 0);
if (currentInner) tl.to(currentInner, { scale: 1.5, duration: d, ease: 'power2.inOut' }, 0);
const at = d * 0.6;   // their 0.65 of a 1.1s timeline
tl.fromTo(upcomingEl, { yPercent: dirSign * 100, scale: 1 },
{ yPercent: 0, duration: d, ease: 'expo' }, at);
if (inEl !== upcomingEl) {
tl.fromTo(inEl, { scale: 1.5, yPercent: dirSign * -30 },
{ scale: 1, yPercent: 0, duration: d, ease: 'expo' }, at);
}
} else {
tl.to(currentEl, { yPercent: dirSign * -100, duration: d, ease: 'power3.inOut' }, 0);
// transformPerspective keeps the 3D local to the slide, so nothing has
// to be added to the section's CSS to make rotationX read.
tl.fromTo(upcomingEl,
{ yPercent: 0, autoAlpha: 0, rotationX: 140, scale: 0.1, z: -1000, transformPerspective: 1000 },
{ autoAlpha: 1, rotationX: 0, z: 0, scale: 1, duration: d, ease: 'power3.inOut' }, d * 0.083);
if (inEl !== upcomingEl) {
tl.fromTo(inEl, { scale: 1.8 }, { scale: 1, duration: d, ease: 'power3.inOut' }, d * 0.14);
}
}
} else if (effect === 'bloom') {
const closedB = pulseWipeFromInset(CFG.maskFrom);
const inB = upcomingInner || upcomingEl;
const outB = d * CFG.outRatio;
const atB  = d * CFG.inDelayRatio;
const durB = d * CFG.inRatio;
tl.set(currentEl, { zIndex: CFG.zBase + 1 }, 0)
.set(upcomingEl, { zIndex: CFG.zBase + 10, opacity: 1, scale: 1, yPercent: 0,
clipPath: closedB }, 0);
// Outgoing recedes — the depth cue push leans on.
tl.to(currentEl, { scale: CFG.seqOutScale, duration: outB, ease: 'power2.inOut' }, 0);
if (currentInner) {
tl.to(currentInner, { scale: CFG.inScale, duration: outB, ease: 'power2.inOut' }, 0);
}
// The outgoing MUST also mask away. Scaling it down without closing its
// mask leaves a shrunken image sitting on the background wherever the
// incoming's centre band hasn't reached yet — that's the "small image"
// artifact. push never showed it because its incoming is a full-bleed
// slide that covers everything; a centre mask only covers progressively.
if (CFG.maskOut) {
tl.fromTo(currentEl, { clipPath: PULSE_WIPE_OPEN },
{ clipPath: outClosed, duration: outB, ease: closeEase }, 0);
}
addScrim(outB, atB, durB);
// Incoming blooms open from the centre, inner sliding + settling.
tl.fromTo(upcomingEl, { clipPath: closedB },
{ clipPath: PULSE_WIPE_OPEN, duration: durB, ease: ease }, atB);
if (inB && inB !== upcomingEl) {
tl.fromTo(inB, { scale: CFG.inScale, yPercent: dirSign * CFG.maskSlideAmt },
{ scale: 1, yPercent: 0, duration: durB, ease: ease }, atB);
}
} else if (effect === 'pulse') {
const closedOut = outClosed;
const inEdge    = (direction === 'prev') ? 'top' : 'bottom';
const closedIn  = pulseWipeFromInset(inEdge);
const inP       = upcomingInner || upcomingEl;
const outDurP   = d * CFG.outRatio;
const inAtP     = d * CFG.inDelayRatio;
const inDurP    = d * CFG.inRatio;
tl.set(currentEl, { zIndex: zOut }, 0)
.set(upcomingEl, { zIndex: zIn, opacity: 1, scale: 1, yPercent: 0,
clipPath: closedIn }, 0);
// OUT — scale down behind a closing centre mask.
if (CFG.maskOut) {
tl.fromTo(currentEl, { clipPath: PULSE_WIPE_OPEN },
{ clipPath: closedOut, duration: outDurP,
ease: closeEase }, 0);
}
addScrim(outDurP, inAtP, inDurP);
if (currentInner) {
tl.to(currentInner, { scale: CFG.seqOutScale, duration: outDurP,
ease: closeEase }, 0);
if (CFG.maskSlide && CFG.maskSlideAmt > 0) {
tl.to(currentInner, { yPercent: dirSign * -CFG.maskSlideAmt * 0.5,
duration: outDurP, ease: closeEase }, 0);
}
}
// IN — mask opens from the direction of travel, inner slides + settles.
tl.fromTo(upcomingEl, { clipPath: closedIn },
{ clipPath: PULSE_WIPE_OPEN, duration: inDurP, ease: ease }, inAtP);
if (inP && inP !== upcomingEl) {
tl.fromTo(inP, { scale: CFG.inScale, yPercent: dirSign * CFG.maskSlideAmt },
{ scale: 1, yPercent: 0, duration: inDurP, ease: ease }, inAtP);
}
} else if (effect === 'sequence') {
const closedSeq = pulseWipeFromInset(CFG.maskFrom);
const inSeq = upcomingInner || upcomingEl;
const p1 = d * CFG.outRatio;
const p2Start = d * CFG.inDelayRatio;
const p2 = d * CFG.inRatio;
tl.set(currentEl, { zIndex: zOut, opacity: 1 }, 0)
.set(upcomingEl, { zIndex: zIn, opacity: 1, scale: 1, yPercent: 0, clipPath: closedSeq }, 0);
// Phase 1 — the current image shrinks away behind its closing mask
// (routed through the shared closeEase defined at the top of goTo).
if (CFG.maskOut) {
tl.fromTo(currentEl, { clipPath: PULSE_WIPE_OPEN },
{ clipPath: outClosed, duration: p1, ease: closeEase }, 0);
}
addScrim(p1, p2Start, p2);
if (currentInner) {
tl.to(currentInner, { scale: CFG.seqOutScale, duration: p1, ease: closeEase }, 0);
if (CFG.maskSlide && CFG.maskSlideAmt > 0) {
tl.to(currentInner, { yPercent: dirSign * -CFG.maskSlideAmt * 0.5,
duration: p1, ease: closeEase }, 0);
}
}
// Phase 2 — the new image opens from the same centre.
tl.fromTo(upcomingEl, { clipPath: closedSeq },
{ clipPath: PULSE_WIPE_OPEN, duration: p2, ease: ease }, p2Start);
if (inSeq && inSeq !== upcomingEl) {
tl.fromTo(inSeq, { scale: CFG.inScale },
{ scale: 1, duration: p2, ease: ease }, p2Start);
if (CFG.maskSlide && CFG.maskSlideAmt > 0) {
tl.fromTo(inSeq, { yPercent: dirSign * CFG.maskSlideAmt },
{ yPercent: 0, duration: p2, ease: ease }, p2Start);
}
}
} else {
// `closed` is the fully-masked inset for the chosen edge. In 'in' mode the
// incoming animates FROM it; in 'out' mode the outgoing animates TO it.
const closed = pulseWipeFromInset(CFG.maskFrom);
const zoomEl = upcomingInner || upcomingEl;
if (CFG.maskMode === 'out') {
// OUT: the outgoing layer sits on top and closes away, revealing the
// incoming (already fully painted) underneath. The opposite read of the
// default — nothing "arrives", something leaves.
// Outgoing is necessarily on top here — closing it away IS the effect —
// so this pair ignores the maskOut ordering. Still routed through zBase
// so it can't sit under an element's own CSS z-index.
tl.set(upcomingEl, { opacity: 1, scale: 1, yPercent: 0, clipPath: PULSE_WIPE_OPEN,
zIndex: CFG.zBase + 1 }, 0)
.set(currentEl, { zIndex: CFG.zBase + 10 }, 0)
// closeEase (mirror of the IN ease by default) for the same reason as
// sequence phase 1: an `.out` ease on a CLOSING mask slams shut.
.fromTo(currentEl, { clipPath: PULSE_WIPE_OPEN },
{ clipPath: closed, duration: d, ease: closeEase }, 0);
} else {
if (!stack) {
tl.set(currentEl, { clipPath: PULSE_WIPE_OPEN, opacity: 1, scale: 1, yPercent: 0, zIndex: CFG.zBase + 1 }, 0);
}
tl.set(upcomingEl, { opacity: 1, scale: 1, yPercent: 0, zIndex: stack ? z : CFG.zBase + 10 }, 0)
.fromTo(upcomingEl, { clipPath: closed },
{ clipPath: PULSE_WIPE_OPEN, duration: d, ease: ease }, 0);
if (CFG.maskOutgoing && !stack && currentEl !== upcomingEl) {
tl.fromTo(currentEl, { clipPath: PULSE_WIPE_OPEN },
{ clipPath: closed, duration: d, ease: closeEase }, 0);
}
}
// Mask + SCALE — the incoming image settles from PULSE_MASK_ZOOM back to 1
// while the band moves, the same gesture the nav menu and intro images use.
// The zoom rides the INNER image, never the wrapper: scaling the wrapper
// would scale its clip too (and push it past the viewport edge). It always
// rides the INCOMING image, in both modes.
if (innerZoom && zoomEl) {
tl.fromTo(zoomEl, { scale: 1 + PULSE_MASK_ZOOM },
{ scale: 1, duration: d, ease: ease }, 0);
}
if (CFG.maskSlide && CFG.maskSlideAmt > 0) {
const amt = CFG.maskSlideAmt;
if (CFG.maskMode === 'out') {
// Old layer is the one on screen — slide it away as it closes.
const outInner = currentInner || currentEl;
if (outInner) tl.to(outInner, { yPercent: dirSign * -amt, duration: d, ease: ease }, 0);
} else {
if (zoomEl) {
tl.fromTo(zoomEl, { yPercent: dirSign * amt },
{ yPercent: 0, duration: d, ease: ease }, 0);
}
if (currentInner) {
tl.to(currentInner, { yPercent: dirSign * -amt * 0.5, duration: d, ease: ease }, 0);
}
}
}
}
}
// Instantly show slide `idx` with no transition (clears any inline transform
// state). Used by the hero intro to hand off onto a specific slide before
// autoplay picks up.
function jumpTo(idx) {
if (!items[idx]) return;
gsap.killTweensOf(items.concat(inner).filter(Boolean));
items.forEach(function (el, i) { el.classList.toggle(currentClass, i === idx); });
gsap.set(items.concat(inner).filter(Boolean), { clearProps: 'transform,opacity,clipPath,zIndex' });
cur = idx;
running.length = 0;
seq = 0;            // collapse the stack
busy = false; pending = null;
}
const api = {
goTo,
jumpTo,
get current() { return cur; },
get isBusy() { return busy; },
setDuration(sec) { CFG.duration = sec; },
setEffect(name) { CFG.effect = name || 'mask'; },
setEase(e) { CFG.ease = e || null; },
setOutEase(e) { CFG.outEase = e || null; },
setMaskFrom(edge) { CFG.maskFrom = edge || 'center'; },
setMaskMode(mode) { CFG.maskMode = (mode === 'out') ? 'out' : 'in'; },
setMaskSlide(on) { CFG.maskSlide = !!on; },
setMaskSlideAmt(pct) { if (pct >= 0) CFG.maskSlideAmt = pct; },
setSeqOutScale(v) { if (v > 0) CFG.seqOutScale = v; },
setInScale(v) { if (v > 0) CFG.inScale = v; },
get inScale() { return CFG.inScale; },
setMaskOut(on) { CFG.maskOut = !!on; },
setMaskOutDir(on) { CFG.maskOutDir = !!on; },
get maskOutDir() { return CFG.maskOutDir; },
setScrimOn(on) { CFG.scrimOn = !!on; },
setScrimOpacity(v) { if (v >= 0) CFG.scrimOpacity = v; },
get maskOut() { return CFG.maskOut; },
get scrimOn() { return CFG.scrimOn; },
setOutRatio(v) { if (v > 0) CFG.outRatio = v; },
setInDelayRatio(v) { if (v >= 0) CFG.inDelayRatio = v; },
setInRatio(v) { if (v > 0) CFG.inRatio = v; },
get outRatio() { return CFG.outRatio; },
get inDelayRatio() { return CFG.inDelayRatio; },
get inRatio() { return CFG.inRatio; },
get seqOutScale() { return CFG.seqOutScale; },
get maskSlide() { return CFG.maskSlide; },
get maskSlideAmt() { return CFG.maskSlideAmt; },
get maskFrom() { return CFG.maskFrom; },
get maskMode() { return CFG.maskMode; },
get effect() { return CFG.effect; },
get ease() { return CFG.ease; },
get outEase() { return CFG.outEase; },
};
// Registered so the motion lab can retune every live swap at once —
// durations are captured in CFG at creation, so changing PULSE_MOTION alone
// would not reach controllers that already exist.
_controllers.push(api);
return api;
}
function linkTriggersToSwap(triggers, swapOpts, eventName) {
const controller = createSwapController(swapOpts);
if (!controller) return null;
const triggerEls = Array.from(triggers || []);
triggerEls.forEach((trigger, i) => {
trigger.addEventListener(eventName || 'mouseenter', () => {
const direction = i > controller.current ? 'next' : 'prev';
controller.goTo(i, direction);
});
});
return controller;
}
global.PulseSwap = {
createSwapController,
linkTriggersToSwap,
// Retune every live controller (the motion lab uses this).
setAllDurations(sec) { _controllers.forEach(function (c) { c.setDuration(sec); }); },
};
})(window);
// The parallax ZOOM BUFFER: the child is scaled to 1 + this. 0.2 = a subtle 120%.
// (This used to feed a runaway 1/(1-2*x) scale — 0.40 there meant 500%, which is
// why images looked 300%+ oversized. It's now linear, so the value ~= the extra
// zoom.) The pan travel is derived from it so the image edges always stay covered.
var PARALLAX_SPEED = 0.40;
// true = image starts high and moves DOWN the page as you scroll (the default
// now). false = the original, starting low and moving up.
var PARALLAX_REVERSE = true;
var _parallaxTriggers = [];
function initParallax() {
// Kill any previous instances before rebuilding — this re-runs on every Barba
// transition, otherwise old ScrollTriggers pile up pointing at detached DOM.
_parallaxTriggers.forEach(function(st) { st.kill(); });
_parallaxTriggers = [];
if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
console.warn('[PulseParallax] GSAP/ScrollTrigger not found — load both before this script.');
return;
}
gsap.registerPlugin(ScrollTrigger);
// When a child is pinned to the wrap's PIXEL height (the min-height/100vh case
// below), that pin is only correct for the current viewport — re-run on resize
// so it tracks. Bound once, debounced.
if (!window._pulseParallaxResizeBound) {
window._pulseParallaxResizeBound = true;
// Width-gated: an iOS toolbar collapse must not trigger a full rebuild
// (kill + recreate every trigger, re-measure every wrap) mid-scroll.
pulseOnResize(function () { initParallax(); }, 200);
}
// Respect reduced-motion: no scroll-driven panning. The image just sits at its
// natural size (we skip the oversize + pan entirely).
if (pulsePrefersReduced()) return;
function parallaxZoomFor(wrap) {
var raw = wrap.getAttribute('data-parallax-zoom');
if (raw == null || raw === '') return PARALLAX_SPEED;
var n = parseFloat(raw);
return (isFinite(n) && n >= 0) ? n : PARALLAX_SPEED;
}
// The largest yPercent that still keeps the edges covered: GSAP translates in
// the SCALED space, so on-screen travel is (yPercent% * height * scale), and
// holding that <= the (scale-1)/2 overflow gives yPercent <= 50*(scale-1)/scale.
// The 0.96 is a hair of slack so rounding never shows a sliver of background.
function parallaxShiftFor(scaleBuffer) {
return 50 * (scaleBuffer - 1) / scaleBuffer * 0.96;
}
var wraps = document.querySelectorAll('.parallax_wrap');
wraps.forEach(function(wrap) {
// Skip the OUTGOING Barba container — it lingers in the DOM (hidden) until
// `after`, and anything built for it is orphaned moments later. The
// display:none check below can't catch this: it sits on the CONTAINER, so the
// wrap's own computed display is still flex/block.
if (wrap.closest('[data-barba="container"].pulse-leaving')) return;
var child = wrap.firstElementChild;
if (!child) return;
// Respect Webflow's RESPONSIVE VISIBILITY. Never touch a wrap or its child that
// Webflow has display:none'd (e.g. the mobile-only bg on desktop). The fill
// below forces display:block on the child — which was UN-HIDING the mobile
// image on desktop and rendering it (portrait) over the desktop one, cropped
// and scaled ("wrong image, scaled wildly").
if (getComputedStyle(wrap).display === 'none' ||
getComputedStyle(child).display === 'none') return;
// A parallax_wrap nested inside another one COMPOUNDS the scale (1.22 x 1.22 =
// ~1.49, the /about over-zoom). We can't safely skip either here — the outer
// sets the box, the inner wraps the media — so we only SCALE/PAN the innermost
// (see isLeafParallax below) while every wrap still fills. The real fix is to
// remove the redundant .parallax_wrap in Webflow so only ONE wraps the media.
var isLeafParallax = !wrap.querySelector('.parallax_wrap');
// Per-wrap zoom + the pan derived from it. Named the same as the old
// module-scope values so everything downstream reads this wrap's numbers.
// The +0.02 is anti-rounding slack for a zoom that exists; at zoom 0 it would
// reintroduce a 2% crop and a sliver of pan, which is exactly what the caller
// asked to be rid of. So zoom 0 means scale 1 and, via the formula, pan 0.
var zoom = parallaxZoomFor(wrap);
var scaleBuffer = zoom > 0 ? 1 + zoom + 0.02 : 1;
var shift = parallaxShiftFor(scaleBuffer);
var target = child;
if (child.hasAttribute('data-anim')) {
target = pulseVisibleChild(child);
if (!target) return;   // nothing shown at this breakpoint — leave it alone
}
if (isLeafParallax) target._pulseParallaxScale = scaleBuffer;
// Wrap must clip the oversized child and establish a positioning context.
wrap.style.position = wrap.style.position || 'relative';
wrap.style.overflow = 'hidden';
// If the WRAP itself has collapsed (a flex child whose only content is the
// image — which we take out of flow below — shrinks to ~0), but its parent has
// real size, stretch the wrap to fill its parent so the image has a box. Guards
// against the /about nested-flex hero collapsing the desktop image to width 0.
var par = wrap.parentElement ? wrap.parentElement.getBoundingClientRect() : null;
if (par) {
var wrc = wrap.getBoundingClientRect();
if (par.width  > 4 && wrc.width  < par.width  * 0.5) wrap.style.width  = '100%';
if (par.height > 4 && wrc.height < par.height * 0.5) wrap.style.height = '100%';
}
// Not truly loaded yet — `complete` can be true while naturalHeight is 0 (a
// lazy <img> that hasn't fetched, or one stalled in an already-collapsed
// wrap). Styling it now forces height:100% against no intrinsic size and
// collapses the wrap. Force it EAGER (beats the lazy-in-a-0px-wrap deadlock),
// re-poke the src so a stalled fetch actually starts, and re-run on decode.
if (child.tagName === 'IMG' && (!child.complete || !child.naturalHeight)) {
if (!child._pulseParallaxRetry) {
child._pulseParallaxRetry = true;
child.loading = 'eager';
child.addEventListener('load', function () { initParallax(); }, { once: true });
if (child.getAttribute('src')) child.src = child.src;
}
return;
}
pulseParallaxFill(wrap, child);
// Only the innermost parallax scales + pans; a nested one would compound the
// zoom. Container wraps still FILL (above) so nothing collapses, they just
// don't animate.
if (!isLeafParallax) return;
if (target !== child) {
// Same undecoded-image trap as above, one level down: styling an <img> with
// no intrinsic size collapses it. Force it eager and come back on decode.
if (target.tagName === 'IMG' && (!target.complete || !target.naturalHeight)) {
if (!target._pulseParallaxRetry) {
target._pulseParallaxRetry = true;
target.loading = 'eager';
target.addEventListener('load', function () { initParallax(); }, { once: true });
if (target.getAttribute('src')) target.src = target.src;
}
return;
}
pulseParallaxFill(child, target);
}
var fit = (wrap.getAttribute('data-parallax-fit') || '').trim();
if (fit) target.style.objectFit = fit;
// (`_pulseParallaxScale` was already stamped on this element above, before the
// decode guards, so a reveal wired in the meantime settles onto the buffer
// rather than onto 1.)
gsap.set(target, {
yPercent: 0,
scale: scaleBuffer,
transformOrigin: '50% 50%',
willChange: 'transform',
});
// Per-instance range overrides for EDGE sections. Tag in Webflow (Element
// settings → Custom attributes):
//   data-parallax="top"     → start at page top   (image top shows on load)
//   data-parallax="bottom"  → end at max scroll   (image bottom shows at end)
//   data-parallax="hero"    → the full-height section AT THE VERY TOP
// Or data-parallax-start / data-parallax-end for full manual control.
var edge    = (wrap.getAttribute('data-parallax') || '').trim();
var isHero  = (edge === 'hero');
var stStart = wrap.getAttribute('data-parallax-start') ||
((edge === 'top' || isHero) ? 'top top' : 'top bottom');
var stEnd   = wrap.getAttribute('data-parallax-end') ||
(edge === 'bottom' ? 'max' : 'bottom top');
var reverse = isHero ? false : PARALLAX_REVERSE;
var revAttr = (wrap.getAttribute('data-parallax-reverse') || '').trim().toLowerCase();
if (revAttr) reverse = !(revAttr === 'false' || revAttr === '0' || revAttr === 'no');
var from = reverse ? -shift : shift;
var tween = gsap.fromTo(target,
{ yPercent: from },     // start of pan
{
yPercent: -from,      // end of pan
ease: 'none',
scrollTrigger: {
trigger: wrap,
start: stStart,
end: stEnd,
scrub: true,
}
}
);
_parallaxTriggers.push(tween.scrollTrigger);
});
// Pinning a child's height (the min-height case above) changes layout AFTER the
// reveal ScrollTriggers were built — if a mask was 0px when its trigger was
// created, that trigger's start/end are stale and it never fires (the reveal
// clip stays shut, blanking the image). Recompute every trigger now that heights
// are correct. Deferred a frame so all wraps have settled first.
if (typeof requestAnimationFrame === 'function') {
requestAnimationFrame(function () { ScrollTrigger.refresh(); });
} else {
ScrollTrigger.refresh();
}
}
window.initParallax = initParallax;
function pulseVisibleChild(el) {
var k = el.firstElementChild;
while (k) {
if (!pulseIsHidden(k)) return k;
k = k.nextElementSibling;
}
return null;
}
function pulseIsHidden(el) {
if (!el._pulseForcedDisplay) return getComputedStyle(el).display === 'none';
var prev = el.style.display;
el.style.display = '';
var hidden = getComputedStyle(el).display === 'none';
if (hidden) el._pulseForcedDisplay = false;   // let the media query own it again
else el.style.display = prev;
return hidden;
}
function pulseParallaxFill(box, child) {
if (pulseIsHidden(child)) return;
// Make the child FILL the box without ever collapsing to 0 (a blank hero):
//  • height:100% works when the parent has a DEFINITE height.
//  • If the parent renders tall via MIN-HEIGHT (a 100vh hero, height:auto), a
//    percentage doesn't resolve and the child goes to 0. Detect THAT (the child
//    collapsed but the wrap is tall) and pin the child to the wrap's rendered
//    pixel height so it fills — kept in sync by the resize re-init below.
//  • If nothing has a height (auto wrap sized BY the image), keep the child's
//    natural height so the image can never vanish. The scale still covers.
// Unconditional, as before — an inline/inline-block <img> ignores height and
// carries a baseline gap, which collapsed the /about mobile hero to 0px when
// this was briefly narrowed to display:'inline' only. Safe to force now
// because the pulseIsHidden() bail above guarantees we never un-hide anything;
// the flag lets pulseIsHidden see past our own value at the next breakpoint.
child.style.display = 'block';
child._pulseForcedDisplay = true;
child.style.width = '100%';
child.style.height = '100%';
child.style.objectFit = 'cover';
// Verify the child actually FILLS the wrap. In-flow width/height:100% fails in
// two common cases: a FLEX hero lays the image out as a COLUMN beside its text
// (partial width), and a MIN-HEIGHT (100vh) parent zeroes a percentage height.
// When it doesn't fill, switch to ABSOLUTE — for a positioned box, 100%
// resolves against the wrap's RENDERED padding box, so it fills either case
// (full bleed). A content sibling later in the DOM still paints on top.
var cr = child.getBoundingClientRect(), wr = box.getBoundingClientRect();
if ((cr.width < wr.width - 2 || cr.height < wr.height - 2) && wr.width > 4 && wr.height > 4) {
child.style.position = 'absolute';
child.style.left = '0';
child.style.top = '0';
// If going absolute collapsed the box (it was sized BY the child), revert.
var wr2 = box.getBoundingClientRect();
if (wr2.width < Math.max(4, wr.width * 0.5) || wr2.height < Math.max(4, wr.height * 0.5)) {
child.style.position = '';
child.style.left = '';
child.style.top = '';
child.style.height = '';
}
}
}
var _revealTriggers = [];
function pulsePrefersReduced() {
return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
// Wrap each word (in every descendant text node) in an inline-block span,
// keeping element children and <br> intact. Returns the word spans in order.
function pulseSplitWords(el, words) {
words = words || [];
Array.prototype.slice.call(el.childNodes).forEach(function(child) {
if (child.nodeType === 3) {                         // text node
if (!child.nodeValue.trim()) return;
var frag = document.createDocumentFragment();
child.nodeValue.split(/(\s+)/).forEach(function(part) {
if (part === '') return;
if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
var span = document.createElement('span');
span.className = 'word';
// NO display override here — a plain inline span around a word renders
// IDENTICALLY to the bare text, so splitting never disturbs the Webflow
// typography (line-height, wrapping, justification). Only when the reveal
// actually transforms each word (yPercent != 0) does the caller promote
// these to inline-block, because transforms don't apply to inline boxes.
span.textContent = part;
frag.appendChild(span);
words.push(span);
});
el.replaceChild(frag, child);
} else if (child.nodeType === 1 && child.nodeName !== 'BR') {
pulseSplitWords(child, words);                     // recurse, keep markup
}
});
return words;
}
// Split an element's text into per-character inline-block spans (spaces become
// non-breaking spaces, kept as plain text so words still separate). Idempotent —
// returns the cached span list if already split. Used by the nav letter-by-letter
// text swap; the spans must be inline-block so each letter can be transformed.
function pulseSplitChars(el) {
if (el._pulseChars) return el._pulseChars;
var text = el.textContent;
el.textContent = '';
var chars = [];
text.split('').forEach(function(ch) {
if (ch === ' ') { el.appendChild(document.createTextNode(' ')); return; }
var span = document.createElement('span');
span.className = 'char';
span.style.display = 'inline-block';
span.style.willChange = 'transform';
span.textContent = ch;
el.appendChild(span);
chars.push(span);
});
el._pulseChars = chars;
return chars;
}
function pulseSplitCharsMasked(el, chars) {
chars = chars || [];
Array.prototype.slice.call(el.childNodes).forEach(function (child) {
if (child.nodeType === 3) {                          // text node
if (!child.nodeValue) return;
var frag = document.createDocumentFragment();
// Keep the separators: split on captured whitespace so the gaps survive as
// plain text nodes and the line can still break between words.
child.nodeValue.split(/(\s+)/).forEach(function (part) {
if (part === '') return;
if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
var word = document.createElement('span');
word.className = 'char_word';
part.split('').forEach(function (ch) {
var mask = document.createElement('span');
mask.className = 'char_mask';
var span = document.createElement('span');
span.className = 'char';
span.textContent = ch;
mask.appendChild(span);
word.appendChild(mask);
chars.push(span);
});
frag.appendChild(word);
});
el.replaceChild(frag, child);
} else if (child.nodeType === 1 && child.nodeName !== 'BR') {
pulseSplitCharsMasked(child, chars);                // recurse, keep markup
}
});
return chars;
}
// LETTER reveal — every character rises out of its own mask, staggered.
// `delay` (seconds) lets the hero heading wait for the hero image to finish.
function pulseRevealLetters(el, cfg, delay) {
// Cache the authored markup so a Barba re-init re-splits from clean HTML
// instead of wrapping already-wrapped characters (same contract as the word
// reveal — and here it matters more, since a double split would nest a mask
// inside a mask and each letter would be clipped twice).
if (el._pulseAnimOrig == null) el._pulseAnimOrig = el.innerHTML;
else el.innerHTML = el._pulseAnimOrig;
var chars = pulseSplitCharsMasked(el);
if (!chars.length) { pulseForceShow(el); return; }
// The FOUC gate hides [data-anim] elements via CSS until their reveal is
// built. The letters carry their own hiding (parked under the mask), so the
// heading itself must be visible for them to slide into.
gsap.set(el, { opacity: 1 });
var spread = Math.min(chars.length * cfg.stagger,
(cfg.maxStagger != null) ? cfg.maxStagger : 1.2);
var tween = gsap.fromTo(chars,
{ yPercent: (cfg.fromYPercent != null) ? cfg.fromYPercent : 118 },
{
yPercent: 0,
duration: cfg.duration,
ease: pulseEase(cfg.ease),
stagger: { amount: spread },
delay: delay || 0,
scrollTrigger: { trigger: el, start: cfg.start, toggleActions: 'play none none none' },
onComplete: function () { gsap.set(chars, { willChange: 'auto' }); },
});
if (tween.scrollTrigger) _revealTriggers.push(tween.scrollTrigger);
pulseArmOnExit(el, tween);
}
function pulseHeroLettersHere() {
var pages = PULSE_MOTION.letters.heroPages;
if (!pages || !pages.length) return true;          // null = every hero
var path = (location.pathname || '/')
.replace(/\/index\.html?$/i, '/')                // harness copies
.replace(/\.html?$/i, '')
.replace(/\/+$/, '');
if (path === '') path = '/';
return pages.some(function (p) {
return path === p.replace(/\/+$/, '');
});
}
function pulseHeroHeadings() {
if (!pulseHeroLettersHere()) return [];
return Array.prototype.filter.call(
document.querySelectorAll('.hero_content h1, .hero_content .display-text'),
function (el) { return !el.closest('[data-barba="container"].pulse-leaving'); });
}
// How long a letters reveal waits for the image mask beside it to finish.
// Derived from the image reveal's own duration, so the two stay paired when
// either is retuned. Applies to every letters reveal, hero or opted-in.
function pulseLetterDelay() {
var d = PULSE_MOTION.letters.delay;
return (d != null) ? d : pulseMaskD(PULSE_MOTION.image.duration);
}
// Re-arm a reveal, but only once the element is FULLY out of view below the fold.
//
// The obvious approach — toggleActions' own `reset` — fires onLeaveBack at the
// reveal's START point, which is deliberately well inside the viewport. Scrolling
// up even slightly would blank an element you're still looking at. 'top bottom' is
// the element's TOP edge meeting the viewport BOTTOM: scroll back past that and it
// is entirely below the fold, so the re-arm is never witnessed — it's simply ready
// to play again next time it comes up.
function pulseArmOnExit(el, anim) {
if (!PULSE_MOTION.replayReveals) return;   // play-once (default): never re-arm
if (typeof ScrollTrigger === 'undefined') return;
var t = ScrollTrigger.create({
trigger: el,
start: 'top bottom',
onLeaveBack: function () { anim.pause(0); }   // back to the start state, paused
});
_revealTriggers.push(t);
}
// IMAGE reveal — clip wipe on the wrapper (direction = PULSE_MOTION.image.from)
// + inner settle on the child. The wrapper carries the clip; its first child
// (the <img> or bg div) carries the scale. CSS gives [data-anim="image"]
// overflow:hidden so the scaled child never spills.
function pulseRevealImage(el, cfg) {
// The child that carries the inner scale settle must be the one Webflow is
// actually SHOWING — a mask often holds both a .desktop and a .mobile variant.
// firstElementChild put the settle (and the _pulseParallaxScale lookup it needs)
// on the hidden desktop image when viewed on a phone, so the visible image never
// settled and the base scale read as undefined.
var child = pulseVisibleChild(el) || el.firstElementChild || el;
// A reveal mask starts CLOSED (clipped), and a clipped/collapsed box is never
// "near the viewport" — so a loading="lazy" image inside it may never fetch and
// the reveal opens onto nothing. Force any image here to load eagerly.
//
// ONLY when this mask can actually be revealed at this breakpoint. No client
// rects means display:none — its own or an ancestor's — and nothing inside a
// display:none wrap will ever be wiped in, so forcing its images eager only
// downloads the OTHER breakpoint's art. Measured on /about at 1280: the page
// pulled the 139KB mobile crop on every desktop load, because .hero_bg_mobile
// and .hero_parallax both carry data-anim="image" and exactly one of them is
// displayed at a time. 221KB -> 82KB on desktop, 221KB -> 139KB on phones.
//
// This does not weaken the rule above. clip-path does not affect layout, so a
// genuinely clipped mask still reports rects and still gets the eager pass; so
// does a zero-height one. display:none is the only case that reports none.
// A resize across the breakpoint later leaves those images lazy, which is
// correct — by then the wrap is laid out and in view, so the browser fetches
// them on its own.
var imgs = (el.tagName === 'IMG') ? [el] : el.querySelectorAll('img');
if (el.getClientRects().length) {
Array.prototype.forEach.call(imgs, function (im) {
if (im.loading === 'lazy') im.loading = 'eager';
if (!im.complete && im.getAttribute('src')) im.src = im.src;
});
}
// A reveal clip and the parallax must not ride the SAME element: the transform
// corrupts the reveal's ScrollTrigger geometry, so the clip never opens and the
// image stays blank (the old /brand-partnerships hero). When this element is a
// .parallax_wrap's direct child, initParallax now steps its scale + pan DOWN to
// the media inside this mask, so the two no longer collide and the reveal can
// run normally. Only bail when there's nothing deeper for the parallax to ride —
// then the transform really is on this element and the clip would never open.
var pw = el.parentElement;
if (pw && pw.classList.contains('parallax_wrap') && pw.firstElementChild === el &&
!el.firstElementChild) {
pulseForceShow(el);
return;
}
var startInset = pulseWipeFromInset(cfg.from);
var tl = gsap.timeline({
// toggleActions: onEnter / onLeave / onEnterBack / onLeaveBack.
// "play none none reset" — play on the way down, and RESET back to the closed
// mask when the trigger scrolls off the bottom again, so scrolling up re-arms
// it and it replays on the next pass (instead of firing once, forever).
// 'play none none none' — the re-arm is handled by pulseArmOnExit below, at a
// point far enough down that you never see it happen.
scrollTrigger: { trigger: el, start: cfg.start, toggleActions: 'play none none none' },
// Drop will-change once revealed — leaving it on promotes layers forever,
// which costs memory on image-heavy pages.
onComplete: function () { gsap.set([el, child].filter(Boolean), { willChange: 'auto' }); },
});
tl.fromTo(el,
{ clipPath: startInset },
{ clipPath: PULSE_WIPE_OPEN, duration: pulseMaskD(cfg.duration), ease: pulseEase(cfg.ease) }, 0);
if (child && cfg.scaleFrom && cfg.scaleFrom !== 1) {
// Settle around the parallax zoom buffer when the parallax rides this same
// element (1.4 stays 1.4, it just arrives from 1.4 x scaleFrom). Plain 1 when
// nothing else owns the transform.
var base = child._pulseParallaxScale || 1;
tl.fromTo(child,
{ scale: base * cfg.scaleFrom },
{ scale: base, duration: pulseMaskD(cfg.duration), ease: pulseEase(cfg.ease) }, 0);
}
if (tl.scrollTrigger) _revealTriggers.push(tl.scrollTrigger);
pulseArmOnExit(el, tl);
}
// TEXT reveal — split to words, each fades in (+ optional rise), staggered.
function pulseRevealText(el, cfg) {
// Cache original markup so a re-init re-splits cleanly instead of wrapping
// already-wrapped words.
if (el._pulseAnimOrig == null) el._pulseAnimOrig = el.innerHTML;
else el.innerHTML = el._pulseAnimOrig;
// Count words WITHOUT splitting first, so long copy never pays for the split.
var wordCount = (el.textContent || '').trim().split(/\s+/).filter(Boolean).length;
var cap = (cfg.wordCap != null) ? cfg.wordCap : 0;
var target, tween;
if (cap > 0 && wordCount > cap) {
// LONG copy — fade the whole element as one. innerHTML is left as authored.
// Use fromTo (not from) with an EXPLICIT end opacity of 1: this branch
// animates the [data-anim] element itself, and while the head FOUC gate is
// on (html.pulse-anim [data-anim]{opacity:0}) a plain .from() would capture
// that gated 0 as its END value and fade 0→0 — the body text would never
// appear. The word-split branch below is immune because it animates child
// spans, whose own computed opacity is 1. Pin the end here so long copy is
// gate-proof.
target = el;
tween = gsap.fromTo(el, {
opacity: 0,
yPercent: cfg.yPercent || 0,
}, {
opacity: 1,
yPercent: 0,
duration: cfg.duration,
ease: pulseEase(cfg.ease),
scrollTrigger: { trigger: el, start: cfg.start, toggleActions: 'play none none none' },
onComplete: function () { gsap.set(el, { willChange: 'auto' }); },
});
} else {
// SHORT copy — the word-by-word cascade, but with the TOTAL spread capped via
// `amount` (not `each`), so it can't run long no matter the word count.
var words = pulseSplitWords(el);
if (!words.length) return;
target = words;
// Only when the reveal moves each word (yPercent) do the spans need to be
// atomic inline-block boxes — transforms don't apply to inline text. For the
// pure opacity fade (yPercent 0, the default) they stay inline, so the split
// is completely invisible to layout. willChange follows suit.
var moves = !!cfg.yPercent;
words.forEach(function (w) {
if (moves) w.style.display = 'inline-block';
w.style.willChange = moves ? 'transform, opacity' : 'opacity';
});
var maxS = (cfg.maxStagger != null) ? cfg.maxStagger : 1.0;
var spread = Math.min(words.length * cfg.stagger, maxS);
tween = gsap.from(words, {
opacity: 0,
yPercent: cfg.yPercent || 0,
duration: cfg.duration,
ease: pulseEase(cfg.ease),
stagger: { amount: spread },
scrollTrigger: { trigger: el, start: cfg.start, toggleActions: 'play none none none' },
onComplete: function () { gsap.set(words, { willChange: 'auto' }); },
});
}
if (tween.scrollTrigger) _revealTriggers.push(tween.scrollTrigger);
pulseArmOnExit(el, tween);
}
// Force an element fully visible (used for reduced-motion, no-GSAP, and error
// fallbacks) — clears any clip/opacity so it can never stay stuck hidden behind
// the FOUC gate (see pulse-head.html).
function pulseForceShow(el) {
if (typeof gsap !== 'undefined') gsap.set(el, { opacity: 1, clipPath: 'none' });
else { el.style.opacity = '1'; el.style.clipPath = 'none'; }
}
// Signal that reveals have been wired and drop the head-snippet FOUC gate, so
// elements are governed by GSAP's inline state (below the fold: still hidden;
// above the fold: mid-reveal) rather than the blanket CSS hide.
function pulseRevealsDone() {
window.__pulseRevealsReady = true;
document.documentElement.classList.remove('pulse-anim');
}
function initReveals() {
_revealTriggers.forEach(function(st) { st.kill(); });
_revealTriggers = [];
// Skip anything still sitting in the OUTGOING Barba container. It stays in the
// DOM (hidden) until `after`, and wiring it here re-split its text and built a
// full set of ScrollTriggers that were orphaned seconds later — 35 dead triggers
// per navigation, recomputing on every scroll and refresh from then on.
var els = Array.prototype.filter.call(
document.querySelectorAll('[data-anim]'),
function (el) { return !el.closest('[data-barba="container"].pulse-leaving'); });
var heroHeadings = pulseHeroHeadings();
heroHeadings.forEach(function (h) { if (els.indexOf(h) === -1) els.push(h); });
function isHeroHeading(el) { return heroHeadings.indexOf(el) !== -1; }
// No GSAP/ScrollTrigger (CDN blocked?) — never leave content hidden behind the
// FOUC gate. Reveal everything and bail.
if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
els.forEach(function(el) { el.style.opacity = '1'; el.style.clipPath = 'none'; });
pulseRevealsDone();
return;
}
var reduce = pulsePrefersReduced();
els.forEach(function(el) {
var effect = (el.getAttribute('data-anim') || '').trim() || 'words';
// The hero title overrides whatever it was tagged as — but never an image.
if (effect !== 'image' && isHeroHeading(el)) effect = 'letters';
try {
if (reduce) {
// Honour reduced-motion: show fully, no split/clip/animation.
if (effect !== 'image' && el._pulseAnimOrig != null) el.innerHTML = el._pulseAnimOrig;
pulseForceShow(el);
return;
}
switch (effect) {
case 'image':
pulseRevealImage(el, PULSE_MOTION.image);
break;
case 'letters':
pulseRevealLetters(el, PULSE_MOTION.letters, pulseLetterDelay());
break;
case 'words':
case 'text':
default:
pulseRevealText(el, PULSE_MOTION.text);
break;
}
} catch (err) {
// One malformed element must never take down the rest — or strand itself
// hidden behind the FOUC gate. Log and force it visible.
console.warn('[PulseReveal] skipped an element:', err);
pulseForceShow(el);
}
});
pulseRevealsDone();
}
window.initReveals = initReveals;
// Back-compat alias: the old engine + Barba after() called initTextAnim().
function initTextAnim() { initReveals(); }
window.initTextAnim = initTextAnim;
// ── Shared menu + page-transition config ─────────────────────────────────
// Menu open/close derive from the global mask duration (read at call time via
// pulseMaskD/pulseMaskCloseD, so live tweaks from the motion panel apply).
var MENU_DUR     = 1.00;    // seconds — the menu panel open; raise to slow the menu
var MENU_ZOOM    = PULSE_MASK_ZOOM;   // shared mask+scale zoom (see PULSE_MASK_ZOOM)
var MENU_EASE    = 'expo.inOut';  // null → inherit the global mask ease (PULSE_MOTION.ease)
var MENU_CLOSE_EASE = 'power2.inOut';
// Center mask — a horizontal band that opens from the vertical centre outward,
// exactly like the intro image reveal (inset: top right bottom left).
// The nav menu's mask edge — the "way it opens". Same vocabulary as the hero:
//   'center'   horizontal band, opens up+down (the original)
//   'center-x' vertical band, opens left+right
//   'top' | 'bottom' | 'left' | 'right'  directional wipe from that edge
var MENU_MASK_FROM   = 'center-x';       // wide screens: vertical band, opens left+right (horizontal motion)
// Responsive override: at/below MENU_MASK_MOBILE_BP the menu opens VERTICALLY —
// a horizontal band at the middle growing up+down — rather than the desktop's
// left+right split. Set MENU_MASK_FROM_MOBILE to null to use the same edge as
// desktop at every width.
var MENU_MASK_FROM_MOBILE = 'center';    // <= 991px: opens up+down (vertical motion)
var MENU_MASK_MOBILE_BP   = 991;         // px — this width and narrower uses the mobile edge
var MENU_MASK_OPEN   = "inset(0% 0% 0% 0%)";
// The edge in force RIGHT NOW — read live so the same open/close picks by the
// current viewport width (and the motion panel can still switch the desktop one).
function menuMaskFrom() {
return (MENU_MASK_FROM_MOBILE && window.innerWidth <= MENU_MASK_MOBILE_BP)
? MENU_MASK_FROM_MOBILE : MENU_MASK_FROM;
}
// Resolved at open/close time so the motion panel can switch it live.
function menuClosedInset() { return pulseWipeFromInset(menuMaskFrom()); }
function menuOpenD()  { return (typeof MENU_DUR === 'number' && MENU_DUR > 0) ? MENU_DUR : pulseMaskD(); }
function menuCloseD() { return menuOpenD() * PULSE_MOTION.maskCloseRatio; }
// Hamburger morph + text swap were absolutes (0.4 / 0.5) tuned against the old
// 1.1 duration; expressing them as fractions of MENU_DUR keeps them in step as
// the menu is retimed. At MENU_DUR 1.0 they resolve to their original values.
function menuMorphD() { return menuOpenD() * 0.4; }
function menuSwapD()  { return menuOpenD() * 0.5; }
function menuCloseEase() { return MENU_CLOSE_EASE || MENU_EASE; }
var PAGE_ORIGIN  = "50% 50%"; // page container origin (Barba transitions)
// The page-transition spec (Barba) — the wipe language. The MENU itself no
// longer uses this (it blurs+fades in via openMenu/closeMenu); this drives the
// page-to-page container transition and the curtain handoff.
//   pageRecede        — null: a wipe covers a static page, so nothing recedes
//   pageLeave         — the leaving container (to)
//   pageEnterFrom/To  — the arriving container (fromTo)
function pulseFxSpec() {
return {
ease: PULSE_MOTION.ease,
pageRecede: null,
pageLeave:  { clipPath: "inset(0% 0% 100% 0%)" },
pageEnterFrom: { clipPath: "inset(100% 0% 0% 0%)", opacity: 1 },
pageEnterTo:   { clipPath: "inset(0% 0% 0% 0%)" },
};
}
function initMenu() {
var menuPanel = document.querySelector(".nav_menu");
var _swapLinks = [];   // {link, sans, serif, isActive} — re-seated on open
document.querySelectorAll(".nav_hamburger_wrap").forEach(function(h) {
var clone = h.cloneNode(true);
h.parentNode.replaceChild(clone, h);
});
var hamburgers = document.querySelectorAll(".nav_hamburger_wrap");
if (!hamburgers.length || !menuPanel) return;
function morphHamburgerToX(hamburgerEl, d) {
var top    = hamburgerEl.querySelector(".nav_icon-top");
var bottom = hamburgerEl.querySelector(".nav_icon-bottom");
if (!top || !bottom) return;
// Measure from the RESTING geometry. getBoundingClientRect() reports the
// post-transform box, so re-measuring a bar that is still mid-morph (open →
// close → open faster than the tween) would fold the current offset into the
// new target and walk the X off centre — y is absolute in GSAP, not relative.
d = d || menuMorphD();
gsap.set([top, bottom], { y: 0, rotate: 0, xPercent: 0, transformOrigin: '50% 50%' });
// Where the stroke actually is, in page coordinates, at rest.
function inkCentre(el) {
var art = el.querySelector('path') || el.querySelector('svg');
var r = (art || el).getBoundingClientRect();
// A zero-height stroked line reports height 0; its centre is still its midline.
return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
}
var topInk = inkCentre(top), bottomInk = inkCentre(bottom);
var topBox = top.getBoundingClientRect(), bottomBox = bottom.getBoundingClientRect();
// Pivot each bar on its own stroke rather than its box centre.
gsap.set(top, {
transformOrigin: (topInk.x - topBox.left) + 'px ' + (topInk.y - topBox.top) + 'px',
});
gsap.set(bottom, {
transformOrigin: (bottomInk.x - bottomBox.left) + 'px ' + (bottomInk.y - bottomBox.top) + 'px',
});
// Both strokes travel to the midpoint BETWEEN THE STROKES, not between the boxes.
var midpoint = (topInk.y + bottomInk.y) / 2;
gsap.fromTo(top,
{ y: 0, rotate: 0 },
{ y: midpoint - topInk.y,    rotate: 45,  duration: d, ease: "power2.inOut" });
gsap.fromTo(bottom,
{ y: 0, rotate: 0 },
{ y: midpoint - bottomInk.y, rotate: -45, duration: d, ease: "power2.inOut" });
}
function morphHamburgerToLines(hamburgerEl, d) {
var top    = hamburgerEl.querySelector(".nav_icon-top");
var bottom = hamburgerEl.querySelector(".nav_icon-bottom");
if (!top || !bottom) return;
d = d || menuMorphD();
gsap.to(top,    { y: 0, rotate: 0, duration: d, ease: "power2.inOut" });
gsap.to(bottom, { y: 0, rotate: 0, duration: d, ease: "power2.inOut" });
}
// Logo layering is CSS-owned: we intentionally do NOT touch the logo's z-index
// from JS (any z-index on the positioned logo spawns a stacking context that
// breaks its mix-blend-mode: exclusion). These stay as no-ops so existing call
// sites don't break.
function showLogoAbovePanel() {}
function hideLogoBelowPanel() {}
var LOGO_HOVER_STAG   = 0.045; // s between letters, left → right
var LOGO_HOVER_D      = 0.34;
var LOGO_SWAP_EASE    = 'expo.inOut';   // the nav swap's curve
var HAM_HOVER_SQUASH  = 0.62;  // scaleX the bars pull back to
var HAM_HOVER_D       = 0.30;
var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
var reduceMotion = window.matchMedia &&
window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function bindLogoHover() {
var logo = document.querySelector('.nav_logo');
if (!logo || !canHover || reduceMotion) return;
// The logo lives OUTSIDE the Barba container, so it is never swapped and
// initMenu re-running must not stack a second set of listeners on it.
if (logo.dataset.pulseHover) return;
logo.dataset.pulseHover = '1';
// P-U-L-S-E as five separate embeds — the split already exists in Webflow,
// so the stagger is just reading the order they're authored in.
var letters = Array.prototype.slice.call(logo.querySelectorAll('[class*="logo_"]'));
if (!letters.length) return;
var pairs = [];
letters.forEach(function (cell) {
var art = cell.firstElementChild;              // the <svg>
if (!art) return;
if (cell.dataset.pulseSwap) return;            // already built
cell.dataset.pulseSwap = '1';
cell.style.position = 'relative';
cell.style.overflow = 'hidden';                // the mask
var clone = art.cloneNode(true);
clone.setAttribute('aria-hidden', 'true');     // decorative duplicate
clone.setAttribute('focusable', 'false');
clone.style.position = 'absolute';
cell.appendChild(clone);
pairs.push({ cell: cell, art: art, clone: clone });
});
if (!pairs.length) return;
function seat() {
pairs.forEach(function (p) {
gsap.set(p.art, { y: 0 });               // measure it untranslated
var cr = p.cell.getBoundingClientRect();
var ar = p.art.getBoundingClientRect();
p.clone.style.left = (ar.left - cr.left) + 'px';
p.clone.style.top  = (ar.top  - cr.top)  + 'px';
gsap.set(p.clone, { y: cr.height || 0 });
});
}
seat();
if (typeof pulseOnResize === 'function') {
pulseOnResize(function () { if (!logo.matches(':hover')) seat(); }, 200);
}
function swap(showClone) {
pairs.forEach(function (p, i) {
var h = p.cell.getBoundingClientRect().height || 0;
var d = i * LOGO_HOVER_STAG;
gsap.to(p.art, {
y: showClone ? -h : 0, duration: LOGO_HOVER_D, ease: LOGO_SWAP_EASE,
delay: d, overwrite: 'auto',
});
gsap.to(p.clone, {
y: showClone ? 0 : h, duration: LOGO_HOVER_D, ease: LOGO_SWAP_EASE,
delay: d, overwrite: 'auto',
});
});
}
logo.addEventListener('mouseenter', function () { swap(true); });
logo.addEventListener('mouseleave', function () { swap(false); });
}
function bindHamburgerHover(btn) {
if (!canHover || reduceMotion) return;
var top    = btn.querySelector('.nav_icon-top');
var bottom = btn.querySelector('.nav_icon-bottom');
if (!top || !bottom) return;
function isOpen() { return !!(window._isNavMenuOpen && window._isNavMenuOpen()); }
var HOLD = (1 - HAM_HOVER_SQUASH) / 2 * 100;   // % to re-pin one end
btn.addEventListener('mouseenter', function () {
if (isOpen()) return;                 // the X is the morph's; leave it alone
gsap.to(top, {
scaleX: HAM_HOVER_SQUASH, xPercent: -HOLD,   // pins the LEFT end
duration: HAM_HOVER_D, ease: 'power3.out', overwrite: 'auto',
});
gsap.to(bottom, {
scaleX: HAM_HOVER_SQUASH, xPercent: HOLD,    // pins the RIGHT end
duration: HAM_HOVER_D, ease: 'power3.out', delay: 0.05, overwrite: 'auto',
});
});
btn.addEventListener('mouseleave', function () {
if (isOpen()) return;
gsap.to([top, bottom], {
scaleX: 1, xPercent: 0, duration: HAM_HOVER_D, ease: 'power3.out',
stagger: 0.05, overwrite: 'auto',
});
});
// Hand the bars to the morph in a known state, instantly, before it starts.
// The pointer is still over the button after a click, so no mouseleave is
// coming to do this for us.
btn.addEventListener('click', function () {
// Scoped to the hover's own properties — an unscoped kill would also take
// out an in-flight morph on a fast double-toggle and strand the bars
// mid-rotation.
gsap.killTweensOf([top, bottom], 'scaleX,xPercent');
gsap.set([top, bottom], { scaleX: 1, xPercent: 0 });
});
}
// The data-nav element for a link: the link itself if it carries the attr,
// else the first descendant that does. (Previously we only checked descendants,
// so when data-nav sat on the anchor the whole list came back empty and the
// image swap silently did nothing.)
function navDataNav(link) {
return link.matches("[data-nav]") ? link : link.querySelector("[data-nav]");
}
function pulseNavPreviewImages() {
var items = document.querySelectorAll(".nav_cms_item");
if (!items.length) {
return { wraps: Array.from(document.querySelectorAll(".nav_image_wrap")),
inner: Array.from(document.querySelectorAll(".nav_image")) };
}
var wantMobile = window.matchMedia
? window.matchMedia("(max-width:991px)").matches
: window.innerWidth <= 991;
var wraps = [], inner = [];
Array.prototype.forEach.call(items, function (item) {
var variants = item.querySelectorAll(".nav_desktop_img, .nav_mobile_img");
var chosen = item.querySelector(wantMobile ? ".nav_mobile_img" : ".nav_desktop_img") ||
variants[0] || null;
Array.prototype.forEach.call(variants, function (v) {
v.classList.toggle("pulse-nav-img-off", v !== chosen);
});
var host = chosen || item;
var wrap = host.querySelector(".nav_image_wrap") || host;
var img  = host.querySelector(".nav_image") || wrap;
if (wrap) { wraps.push(wrap); inner.push(img); }
});
Array.prototype.forEach.call(document.querySelectorAll(".nav_image_wrap"), function (w) {
if (wraps.indexOf(w) === -1) w.classList.remove("is-current");
});
return { wraps: wraps, inner: inner };
}
function setupNavHoverPreviews() {
var navLinksWrap = document.querySelector(".nav_links");
if (!navLinksWrap) return;
var freshWrap = navLinksWrap.cloneNode(true);
navLinksWrap.parentNode.replaceChild(freshWrap, navLinksWrap);
navLinksWrap = freshWrap;
var cmsLinkItems = navLinksWrap.querySelectorAll(".nav_cms_link_item .nav_link");
var navLinkEls = cmsLinkItems.length
? Array.from(cmsLinkItems)
: Array.from(navLinksWrap.querySelectorAll(".nav_link"))
.filter(function(link) { return navDataNav(link); });
var activeNs = (window._currentNamespace || "").trim();
var activeIdx = navLinkEls.findIndex(function(link) {
var navTextEl = navDataNav(link);
return navTextEl && navTextEl.dataset.nav === activeNs;
});
if (activeIdx === -1) activeIdx = 0;
// ── Image swap (may legitimately be absent on some pages/layouts) ──
var navPreview = pulseNavPreviewImages();
var navImages = navPreview.wraps;
if (navImages.length) {
var swapController = PulseSwap.createSwapController({
items: navImages,
inner: navPreview.inner,
duration: PULSE_MOTION.maskDuration,
// .nav_image_wrap carries z-index:90 from this file's own stylesheet, so
// the stack MUST start above that — with the old 1..20 range the incoming
// mask opened UNDERNEATH the current image and you saw nothing until the
// timeline ended. 90+9 tops out at 99, still under the nav bar's 100.
zBase: 90,
zCeil: 9,
// Skate across the links and each one starts opening its mask over the
// last. Bounded so fast hovering can't pile up unlimited live masks.
stack: 4,
currentClass: "is-current",
initialIndex: activeIdx,
});
// Image preview swap is a hover affordance — bind it only on real hover
// devices (same touch reasoning as the text swap below).
if (swapController && pulseCanHover()) {
navLinksWrap.addEventListener("mouseover", function(e) {
var link = e.target.closest(".nav_link");
if (!link) return;
var idx = navLinkEls.indexOf(link);
if (idx === -1) return;
var direction = idx > swapController.current ? "next" : "prev";
swapController.goTo(idx, direction);
hideLogoBelowPanel();
});
navLinksWrap.addEventListener("mouseleave", function() {
showLogoAbovePanel();
});
}
}
// ── Text swap (sans/serif) — always runs, independent of image swap ──
setupTextSwapStates(navLinksWrap, navLinkEls, activeIdx);
}
setupNavHoverPreviews();
// Pure masked slide — NO opacity crossfade. The .text-swap_wrap clips
// (overflow:hidden) so only one line shows: one slides out as the other slides
// in. Crucially the slide distance is the WRAP's height (the mask), NOT the
// text's own height. The old code slid by yPercent:101 of the text — when a
// link's line-box is taller than its glyphs (e.g. the Instagram link) that
// didn't clear the mask and the hidden line peeked back in (the doubling).
// The wrap is measurable only when the menu is open, so callers pass animate:
// false at rest (openMenu re-seats once laid out) and true on hover.
// Per-letter stagger for the swap (seconds between adjacent letters). 0 makes
// the whole line move together — the old word/line behaviour.
var NAV_LETTER_STAGGER = 0.03;
// entry = { link, sansChars[], serifChars[], isActive }. Each label is split
// into per-letter inline-block spans (pulseSplitChars) so the sans slides out
// and the serif slides in LETTER BY LETTER, staggered left→right, rather than
// the line moving as one block. Every letter still travels the WRAP's height so
// the wrap's overflow:hidden masks it cleanly.
function textSwapSet(entry, showSerif, animate) {
var h = entry.link.getBoundingClientRect().height;
var sansChars = entry.sansChars, serifChars = entry.serifChars;
if (!h) {  // menu closed / not laid out yet — openMenu will re-seat with a real height
gsap.set(sansChars.concat(serifChars), { y: 0, opacity: 1 });
return;
}
var sansY  = showSerif ? -h : 0;
var serifY = showSerif ? 0  : h;
if (animate) {
gsap.to(sansChars,  { y: sansY,  duration: menuSwapD(), ease: "expo.inOut", stagger: NAV_LETTER_STAGGER });
gsap.to(serifChars, { y: serifY, duration: menuSwapD(), ease: "expo.inOut", stagger: NAV_LETTER_STAGGER });
} else {
gsap.set(sansChars,  { y: sansY });
gsap.set(serifChars, { y: serifY });
}
}
// Re-seat every link's rest state (called by openMenu, when heights are real).
function reseatTextSwaps() {
_swapLinks.forEach(function(o) { textSwapSet(o, o.isActive, false); });
}
function setupTextSwapStates(navLinksWrap, navLinkEls, activeIdx) {
var allLinks = Array.from(navLinksWrap.querySelectorAll(".nav_link"));
var activeLinkEl = navLinkEls[activeIdx] || null;
var canHover = pulseCanHover();
_swapLinks = [];
if (!canHover || (window.matchMedia && !window.matchMedia('(min-width: 992px)').matches)) return;
allLinks.forEach(function(link) {
var sansEl  = link.querySelector(".text-swap_sans");
var serifEl = link.querySelector(".text-swap_serif");
if (!sansEl || !serifEl) return;
var isActive = link === activeLinkEl;
var entry = {
link: link, sans: sansEl, serif: serifEl, isActive: isActive,
sansChars:  pulseSplitChars(sansEl),
serifChars: pulseSplitChars(serifEl),
};
_swapLinks.push(entry);
// Seat now (height may be 0 if the menu is closed — openMenu re-seats).
textSwapSet(entry, isActive, false);
// Hover swap ONLY on real hover devices. On touch, binding these would
// eat the first tap (hover) and force a second tap to navigate.
if (canHover) {
link.addEventListener("mouseenter", function() { textSwapSet(entry, !isActive, true); });
link.addEventListener("mouseleave", function() { textSwapSet(entry, isActive,  true); });
}
});
}
// Menu open/close: the WHOLE .nav_menu MASKS in/out from the vertical centre
// (a horizontal band that opens outward) + a subtle zoom — the same reveal the
// intro images use. When the menu is the page-transition curtain, this mask-out
// IS the reveal.
function openMenu() {
armNavPreviewImages();   // backstop — see armNavPreviewImages()
var visibleH = Array.from(hamburgers).find(function(h) {
var r = h.getBoundingClientRect();
return r.width > 0 && r.height > 0;
});
if (visibleH) morphHamburgerToX(visibleH);
gsap.set(menuPanel, { display: "flex" });
// Lock page scroll behind the full-screen panel. Without this the page kept
// scrolling under the open menu on touch, which both looks broken and (on
// iOS) collapses the URL bar — firing the resize handler that force-closes
// the menu. On <html>, not <body>: the more reliable form on iOS, and the
// same thing the lightbox does.
document.documentElement.style.overflow = "hidden";
// Now the panel is laid out, the link mask heights are real — seat the
// sans/serif rest positions before the panel appears.
reseatTextSwaps();
gsap.fromTo(menuPanel,
{ clipPath: menuClosedInset(), scale: 1 + MENU_ZOOM, opacity: 1 },
{ clipPath: MENU_MASK_OPEN, scale: 1, duration: menuOpenD(), ease: pulseEase(MENU_EASE) });
showLogoAbovePanel();
}
// onClosed (optional) fires once the panel is fully closed + hidden — Barba's
// transition awaits it when the menu is the page-transition curtain.
function closeMenu(onClosed) {
var visibleH = Array.from(hamburgers).find(function(h) {
var r = h.getBoundingClientRect();
return r.width > 0 && r.height > 0;
});
// Same duration as the panel, so the icon and the menu leave together.
if (visibleH) morphHamburgerToLines(visibleH, menuCloseD());
function finish() {
gsap.set(menuPanel, { display: "none", clearProps: "clipPath,transform,scale,opacity,filter" });
document.documentElement.style.overflow = "";   // release the scroll lock
hideLogoBelowPanel();
if (typeof onClosed === "function") onClosed();
}
gsap.to(menuPanel, { clipPath: menuClosedInset(), scale: 1 + MENU_ZOOM,
duration: menuCloseD(), ease: pulseEase(menuCloseEase()), onComplete: finish });
}
gsap.set(menuPanel, { display: "none" });
var _navImagesArmed = false;
function armNavPreviewImages() {
if (_navImagesArmed) return;
_navImagesArmed = true;
document.querySelectorAll(".nav_image").forEach(function (img) {
if (img.tagName !== 'IMG' || img.getAttribute('loading') !== 'lazy') return;
var variant = img.closest(".nav_desktop_img, .nav_mobile_img");
if (variant && variant.classList.contains("pulse-nav-img-off")) return;
img.loading = 'eager';
if (img.getAttribute('src')) img.src = img.src;
});
}
window._armPulseNavImages = armNavPreviewImages;
function toggleMenu() {
if (window._isNavMenuOpen && window._isNavMenuOpen()) {
closeMenu();
} else {
openMenu();
}
}
// Hovers first, so their click reset runs before toggleMenu flips the state
// the hover branches read.
bindLogoHover();
hamburgers.forEach(bindHamburgerHover);
hamburgers.forEach(function (btn) {
btn.addEventListener("pointerenter", armNavPreviewImages, { once: true, passive: true });
btn.addEventListener("pointerdown",  armNavPreviewImages, { once: true, passive: true });
});
hamburgers.forEach(function(btn) { btn.addEventListener("click", toggleMenu); });
window._closeNavMenu = closeMenu;
window._isNavMenuOpen = function() {
return window.getComputedStyle(menuPanel).display !== "none";
};
}
var NAV_VARIANT_CLASS = "w-variant-4e2c3d2f-d7b7-6ccc-4df1-4479cf42c8d3";
var LIGHT_MODE_PAGES   = ["about", "brand-partnerships"];
function applyNavVariant(namespace) {
var ns = (namespace || "").trim();
var isLight = LIGHT_MODE_PAGES.indexOf(ns) !== -1;
var navRoot  = document.querySelector("nav.nav");
if (navRoot) {
navRoot.setAttribute("data-wf--navbar--variant", isLight ? "light-mode" : "base");
}
[".nav_logo", ".nav_menu", ".nav_hamburger_wrap"].forEach(function(selector) {
document.querySelectorAll(selector).forEach(function(el) {
el.classList.toggle(NAV_VARIANT_CLASS, isLight);
});
});
// NOTE: we deliberately do NOT set the logo's inline color here — it uses
// fill="currentColor" with mix-blend-mode: exclusion; forcing a color would
// override CSS and change what exclusion composites. Drive it from CSS off the
// variant class / data-wf--navbar--variant attribute instead.
}
pulseReady(function() {
var initialContainer = document.querySelector('[data-barba="container"]');
window._currentNamespace = initialContainer ? (initialContainer.dataset.barbaNamespace || "").trim() : null;
applyNavVariant(window._currentNamespace);
_pulseWideNav = !window.matchMedia || window.matchMedia('(min-width: 992px)').matches;
initMenu();
initParallax();
initReveals();
pulseWatchImages();   // lazy images land later and move everything below them
pulseRefresh();       // re-measure once triggers are in place
});
// Force the menu shut on a REAL resize (rotation, desktop window drag) — its
// clip mask and slide distances are measured for one viewport. Width-gated: this
// used to run on every iOS URL-bar collapse, so opening the menu on an iPhone and
// dragging made it disappear un-animated with the hamburger snapping back.
var _pulseWideNav = null;   // last known state of the 992px nav-swap breakpoint
pulseOnResize(function () {
var menuPanel  = document.querySelector(".nav_menu");
var hamburgers = document.querySelectorAll(".nav_hamburger_wrap");
if (menuPanel) gsap.set(menuPanel, { display: "none", clearProps: "clipPath,transform,scale,opacity,filter" });
document.documentElement.style.overflow = "";   // never strand the scroll lock
hamburgers.forEach(function(h) {
var top    = h.querySelector(".nav_icon-top");
var bottom = h.querySelector(".nav_icon-bottom");
if (top)    gsap.set(top, { y: 0, rotate: 0 });
if (bottom) gsap.set(bottom, { y: 0, rotate: 0 });
});
var wide = !window.matchMedia || window.matchMedia('(min-width: 992px)').matches;
if (wide !== _pulseWideNav) {
_pulseWideNav = wide;
initMenu();
}
});
const DUR = 0.65;
function updateNavActive(namespace) {
var ns = (namespace || "").trim();
window._currentNamespace = ns;
applyNavVariant(ns);
document.querySelectorAll("[data-nav], .nav_logo")
.forEach(el => el.classList.remove("w--current"));
const active = document.querySelector(`[data-nav="${ns}"]`);
if (active) active.classList.add("w--current");
if (ns === "home") {
document.querySelector(".nav_logo")?.classList.add("w--current");
}
}
if (typeof barba === 'undefined') {
console.warn('[PulseEngine] Barba not found — page transitions disabled; the rest of the engine still runs.');
} else if (!PULSE_PAGE_TRANSITIONS) {
console.info('[PulseEngine] Page transitions temporarily OFF (PULSE_PAGE_TRANSITIONS = false) — links do normal full-page loads.');
} else {
// Full-screen white veil for the page transition. Fixed above everything (incl.
// the nav), starts transparent, created once.
function pulsePageVeil() {
var v = document.getElementById('pulse-page-veil');
if (!v) {
v = document.createElement('div');
v.id = 'pulse-page-veil';
v.style.cssText = 'position:fixed;inset:0;background:#fff;opacity:0;' +
'pointer-events:none;z-index:2147483600;';
document.body.appendChild(v);
}
return v;
}
// Copy the INCOMING page's Webflow identity onto <html>. `data-wf-page` (and
// `data-wf-site`) live on the <html> tag, OUTSIDE the Barba container, so Barba
// never swaps them — they keep the FIRST page's ids for the whole session.
// Webflow's ix2 reads data-wf-page to decide which page's interactions to load,
// so without this the new page runs the PREVIOUS page's interactions (the
// classic "buggy layout / needs two clicks" Barba+Webflow bug). Regex, not
// DOMParser, so we don't kick off a second fetch of the page's subresources.
function pulseSyncWfPage(html) {
if (!html) return;
try {
var p = html.match(/<html[^>]*\bdata-wf-page="([^"]+)"/i);
if (p && p[1]) document.documentElement.setAttribute('data-wf-page', p[1]);
var s = html.match(/<html[^>]*\bdata-wf-site="([^"]+)"/i);
if (s && s[1]) document.documentElement.setAttribute('data-wf-site', s[1]);
} catch (e) {  }
}
var PAGE_FADE_D = 0.4;   // each half of the dip (out to white, back in)
function pulseArmVeilFailsafe() {
clearTimeout(window._pulseVeilFailsafe);
window._pulseVeilFailsafe = setTimeout(function () {
var f = pulsePageVeil();
gsap.set(f, { opacity: 0 }); f.style.pointerEvents = "none";
document.documentElement.classList.remove("pulse-animating");
document.documentElement.classList.remove("pulse-anim");
}, 4000);
}
function pulseVeilTo(veil, to) {
return new Promise(function (res) {
var settled = false;
function finish() {
if (settled) return;
settled = true;
gsap.killTweensOf(veil);
gsap.set(veil, { opacity: to });
res();
}
gsap.to(veil, { opacity: to, duration: PAGE_FADE_D, ease: "power2.inOut", onComplete: finish });
setTimeout(finish, PAGE_FADE_D * 1000 + 1500);   // generous: only catches a stalled ticker
});
}
barba.init({
prevent: ({ el }) => {
if (!el || !el.getAttribute) return false;
var href = el.getAttribute("href") || "";
return el.classList.contains("no-transition") ||
el.hasAttribute("download") ||
el.getAttribute("target") === "_blank" ||
/^(#|mailto:|tel:|javascript:)/i.test(href);
},
transitions: [{
name: "fade-white",
// DIP TO WHITE: the leaving page fades to a full-white veil, Barba swaps the
// page behind it, then the veil fades back out to reveal the new page. Simple
// and nav-state-agnostic — the veil covers the (often open) menu, which we
// then force shut behind it so the new page never shows it open.
async leave() {
var veil = pulsePageVeil();
veil.style.pointerEvents = "auto";   // block clicks mid-transition
pulseArmVeilFailsafe();
// Dip to white.
await pulseVeilTo(veil, 1);
// ONLY NOW mark the transition. This used to be the first line of leave(),
// and back then the class took the leaving container out of flow — which
// collapsed the document to one viewport and force-scrolled the browser to
// 0, snapping a scrolled-down page to the top while the veil was still
// transparent. That was the visible jump on every navigation. The class is
// now just a state flag (the layout swap moved to .pulse-leaving on the
// container itself), but it still belongs behind the white.
document.documentElement.classList.add("pulse-animating");
// Fully white now — force the (possibly open) menu shut behind the veil.
var menuPanel = document.querySelector(".nav_menu");
if (menuPanel) gsap.set(menuPanel, { display: "none", clearProps: "clipPath,transform,scale,opacity,filter" });
// This path bypasses closeMenu()'s finish(), so release the scroll lock
// here too — otherwise navigating from an open menu leaves <html> stuck at
// overflow:hidden and the new page cannot be scrolled at all.
document.documentElement.style.overflow = "";
document.querySelectorAll(".nav_hamburger_wrap").forEach(function (h) {
var t = h.querySelector(".nav_icon-top"), b = h.querySelector(".nav_icon-bottom");
if (t) gsap.set(t, { y: 0, rotate: 0 });
if (b) gsap.set(b, { y: 0, rotate: 0 });
});
},
// REBUILD HERE — while the veil is STILL FULLY WHITE (opaque from leave, not
// faded until enter). The old container is already gone by beforeEnter, so we
// re-init the new page, run its reveals, and re-measure ScrollTriggers behind
// the cover. Doing this in after() (post-enter) was the "buggy on swap" flash:
// the veil lifted onto an un-rebuilt page and reveals/parallax/hero/ix2 then
// snapped in a beat late. Now the page is finished before it's ever seen.
beforeEnter({ current, next }) {
// The OLD container is still in the DOM here — Barba only removes it around
// `after`. It used to be left in place and merely pinned to top:0 alongside
// the new one, which meant the document measured ONE VIEWPORT tall for the
// whole rebuild: every ScrollTrigger built below got start/end clamped into
// a zero-length scroll range, so the incoming page's reveals all fired at
// once behind the veil instead of on scroll. Take the leaving container out
// of the layout entirely (it is invisible under the white veil anyway) and
// the new container is alone in normal flow at its REAL height — the same
// geometry a fresh page load gets.
pulseArmVeilFailsafe();   // the fetch is done; restart the clock for the rebuild
if (current && current.container) current.container.classList.add("pulse-leaving");
// Re-arm the head FOUC gate (html.pulse-anim hides [data-anim] via CSS) so
// the incoming markup can never paint un-revealed. initReveals() drops it
// again in enter(); the leave() failsafe drops it if we never get there.
document.documentElement.classList.add("pulse-anim");
window.__pulseRevealsReady = false;
window.scrollTo(0, 0);
updateNavActive(next.namespace);
try {
// Point <html data-wf-page> at the NEW page BEFORE re-initing Webflow, or
// ix2 loads the previous page's interactions (see pulseSyncWfPage).
pulseSyncWfPage(next && next.html);
// Drop the LEAVING page's ScrollTriggers. Testing by detachment alone
// silently did nothing — the old container is still in the DOM at this
// point, so nothing looked detached and every page leaked its full set
// (34 dead triggers after a single navigation, recomputing on every
// scroll and refresh from then on). Match on container ownership too.
if (window.ScrollTrigger) {
var leaving = current && current.container;
ScrollTrigger.getAll().forEach(function (st) {
var t = st.trigger;
if (!t) return;
if (!document.documentElement.contains(t) ||
(leaving && leaving.contains(t))) st.kill();
});
}
initMenu();
if (typeof window.initHeroSlider === "function") window.initHeroSlider();
if (typeof window.initParallax === "function") window.initParallax();
if (window.Webflow) {                 // re-init Webflow ix2/forms/tabs/sliders
window.Webflow.destroy();
window.Webflow.ready();             // re-runs tabs, sliders, lightbox, forms…
// `require("ix2")` returns UNDEFINED on a site with no Webflow
// interactions — which this one is (zero script.w-json blocks; the
// motion is all GSAP). Calling .init() on that threw on every single
// navigation, and because the throw landed inside this try block it
// also skipped pulseWatchImages below — so lazy images that arrived
// during the swap never triggered a re-measure. Ask, don't assume.
var ix2 = window.Webflow.require && window.Webflow.require("ix2");
if (ix2 && typeof ix2.init === "function") ix2.init();
}
pulseWatchImages(next.container || document);
} catch (e) { console.warn("[PulseEngine] beforeEnter re-init error:", e); }
},
async enter() {
pulseArmVeilFailsafe();   // rebuild is done; restart the clock for the lift
var veil = pulsePageVeil();
// One frame before measuring anything. beforeEnter's Webflow.destroy()/
// ready() can still be settling layout (fonts, ix2, CMS binding) on the
// same tick enter() starts — measuring ScrollTrigger positions before that
// settles is what made just-below-the-fold reveals compute a start/end
// that a later refresh() finds already behind the scroll position, so they
// snap straight to their done state instead of animating in. One rAF is
// ~16ms against a multi-hundred-ms veil fade, so it doesn't reintroduce
// the "reveals fire late" problem the next comment is about.
await pulseNextFrame();
// Wire the reveals HERE, not in beforeEnter. Above-the-fold reveals fire the
// moment their trigger is created, so building them behind an opaque veil
// burned the first 0.4s of a ~1s reveal and you arrived on a page that had
// already half-animated itself. Created as the veil starts lifting, they
// play THROUGH the fade — the same entrance a fresh load gives you. This
// also drops the pulse-anim gate re-armed in beforeEnter.
try {
if (typeof window.initParallax === "function") window.initParallax();
if (typeof window.initReveals === "function") window.initReveals();
} catch (e) {
console.warn("[PulseEngine] enter reveals error:", e);
document.documentElement.classList.remove("pulse-anim");   // never strand content hidden
}
await pulseVeilTo(veil, 0);
veil.style.pointerEvents = "none";
},
after() {
clearTimeout(window._pulseVeilFailsafe);
// Old container is gone now — clear the transition flags and re-measure.
// The height was already correct through beforeEnter/enter (the leaving
// container was out of flow), so this is a confirmation pass, not a repair:
// fonts and lazy images that landed during the swap can still move things.
document.documentElement.classList.remove("pulse-animating");
document.documentElement.classList.remove("pulse-anim");
var v = document.getElementById("pulse-page-veil");
if (v) { gsap.set(v, { opacity: 0 }); v.style.pointerEvents = "none"; }
pulseRefresh();
},
}],
views: [{
beforeEnter({ next }) {
updateNavActive(next.namespace);
}
}]
});
}
const style = document.createElement("style");
style.textContent = `
[data-barba="wrapper"] {
overflow-x: hidden;
position: relative;
}
[data-barba="container"] {
width: 100%;
}
[data-barba="container"].pulse-leaving {
display: none !important;
}
.nav_menu {
}
.nav_images {
position: relative;
}
.nav_image_wrap {
position: absolute;
inset: 0%;
width: 100%;
height: 100%;
opacity: 0;
pointer-events: none;
overflow: hidden;
z-index: 90;
}
.nav_image_wrap:first-child {
position: relative; 
}
.nav_images .nav_cms_list_wrapper,
.nav_images .nav_cms_list {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
}
.nav_images .nav_cms_item,
.nav_images .nav_desktop_img,
.nav_images .nav_mobile_img {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
}
.nav_desktop_img.pulse-nav-img-off,
.nav_mobile_img.pulse-nav-img-off {
display: none !important;
}
.nav_image_wrap.is-current {
opacity: 1;
pointer-events: none;
}
.nav_image {
width: 100%;
height: 100%;
object-fit: cover;
will-change: transform, opacity;
}
.nav_icon-top,
.nav_icon-bottom {
transform-origin: 50% 50%;
}
.nav_icon-top svg,
.nav_icon-bottom svg {
display: block;
width: 100%;
height: auto;
}
[data-anim="image"] {
overflow: hidden;
}
[data-anim="image"] > * {
will-change: transform;
}
.char_word {
display: inline-block;
white-space: nowrap;   
}
.char_mask {
display: inline-block;
clip-path: inset(-0.45em -0.2em 0 -0.2em);
}
.char_mask > .char {
display: inline-block;
will-change: transform;
}
.nav_menu .text-swap_wrap {
display: grid !important;
align-items: center;
justify-items: center;
padding: 0 1em;
overflow: hidden;
position: relative;
}
@media (min-width: 992px) {
.nav_menu .text-swap_wrap { justify-items: start; justify-content: start; }
.nav_menu .text-swap_wrap > .text-swap_sans,
.nav_menu .text-swap_wrap > .text-swap_serif {
justify-self: start;
margin-left: 0;
margin-right: 0;
text-align: left;
}
}
.nav_menu .text-swap_wrap > .text-swap_sans,
.nav_menu .text-swap_wrap > .text-swap_serif {
grid-area: 1 / 1;
position: relative !important;
transition: none !important;
will-change: transform;
white-space: nowrap;
}
@media (max-width: 991px), (hover: none) {
.nav_menu .text-swap_wrap {
display: block !important;
overflow: visible;
padding: 0;
}
.nav_menu .text-swap_wrap > .text-swap_sans,
.nav_menu .text-swap_wrap > .text-swap_serif {
transform: none !important;
will-change: auto;
white-space: normal;
}
.nav_menu .text-swap_wrap > .text-swap_serif { display: none; }
.nav_menu .text-swap_wrap.w--current > .text-swap_sans { display: none; }
.nav_menu .text-swap_wrap.w--current > .text-swap_serif { display: block; }
}
`;
document.head.appendChild(style);
;
var heroControllerDesktop = null;
var heroControllerMobile  = null;
var heroAutoplayDesktop   = null;
var heroAutoplayMobile    = null;
// Set to a number to make the HERO swap faster than the rest of the site's
// centre masks. 0.7 because a full 1.1s per slide is most of why scrolling the
// deck feels sluggish — no input tuning can compensate for the slide itself
// taking over a second to resolve. The nav/menu/reveals still run at
// PULSE_MOTION.maskDuration, so the site's motion language is unchanged.
// Set back to null to inherit the global duration again.
var HERO_SWAP_DUR_OVERRIDE = 1.00;
var HERO_SWAP_EASE = 'quint.inOut';
var HERO_SWAP_OUT_EASE = 'quint.in';
var HERO_SWAP_DUR = HERO_SWAP_DUR_OVERRIDE != null
? HERO_SWAP_DUR_OVERRIDE
: ((typeof PULSE_MOTION !== 'undefined') ? PULSE_MOTION.maskDuration : 1.1);
var HERO_HOLD_SECONDS = 4;     // autoplay hold between slides
// How many slide masks may be open AT ONCE. Keep scrolling and the next one starts
// over the last rather than waiting — but only this deep, so it stays legible.
// Raise for more pile-up, set to `true` for unbounded, 1 for strictly one at a time.
// Input is never dropped: at the cap the oldest mask is sped up to free a slot.
var HERO_MAX_STACK = 2;
function startHeroAutoplays() {
if (heroAutoplayDesktop) heroAutoplayDesktop.play();
if (heroAutoplayMobile)  heroAutoplayMobile.play();
}
// Instantly put both hero decks on slide `idx` (no transition). The intro uses
// this to hand off onto a specific slide before autoplay starts.
function heroJumpTo(idx) {
if (heroControllerDesktop && heroControllerDesktop.jumpTo) heroControllerDesktop.jumpTo(idx);
if (heroControllerMobile  && heroControllerMobile.jumpTo)  heroControllerMobile.jumpTo(idx);
}
// Seconds — wall-clock teardown backstop (fires at this + 2). Must stay clear of
// the longest real timeline or it would cut a legitimate intro short: the slowest
// case (7 images, mobile TS 1.2) lands at ~6.9s including the fade, so 7 → 9s.
var HERO_INTRO_FAILSAFE = 7;
// px — portrait/mobile build at/below this width. 767, NOT 768: it must match the
// width at which Webflow swaps the decks (`.mobile_image` gets display:block at
// max-width:767px), or at exactly 768 the intro builds the portrait layout around
// DESKTOP art. Measured at 768 before the fix: portrait framing, hero-01_desktop.
var HERO_STACK_BP       = 767;
// Aspect ratio for an intro frame whose art hasn't decoded yet and whose deck
// offers no decoded sibling to borrow from. 16:9 because that is what the
// desktop deck actually is (measured 1920x1080); the mobile deck is 9:16 and is
// always decoded by intro time, so it never reaches this fallback. If the
// desktop art ever stops being 16:9, this constant is the thing to revisit —
// the frames would be built to the wrong box before the images land.
var HERO_INTRO_FALLBACK_AR = 16 / 9;
// ── Signature intro tuning (coded rebuild of the Jitter timeline) ─────────────
// One place to refine the pacing/feel. Mirrors the Jitter effect settings:
//   Letters = "Slide & Blur" (blur 50, slide 60, →, Slow-down)
//   Images  = "Mask Center"  (horizontal, zoom content, Smooth), 7 stacked images
//             scaled ~30%→100%, revealed smallest→largest (last = hero slide 0)
//   Letters then "Slide & Blur out" (same, reversed); then the nav slides+blurs in.
// Durations are scaled by TS for the portrait/mobile build.
var SIG = {
letterDur:    0.6,          // per-letter blur+slide (Jitter 0.74; client wants ~0.5)
letterStag:   0.1,          // stagger between letters
letterSlide:  60,           // px slide, visual (Jitter "Slide by 60")
letterBlur:   50,           // px blur,  visual (Jitter "Blur radius 50")
letterEaseIn: 'power2.out',  // "Slow down"
letterEaseOut:'power2.in',
imgStartGap:  0.15,         // beat AFTER the last letter has fully landed, before the images begin
imgDur:       0.50,         // per-image mask-center reveal (Jitter 1s)
imgStag:      0.34,         // stagger between images — they read one at a time, not as a rush
// "zoom content" during the mask. Shared with every other centre mask on the
// site (PULSE_MASK_ZOOM in the engine) so the gesture is identical everywhere.
imgZoom:      (typeof PULSE_MASK_ZOOM !== 'undefined') ? PULSE_MASK_ZOOM : 0.06,
imgEase:      null,         // null → inherit PULSE_MOTION.ease (the global mask ease)
imgMinScale:  0.30,         // smallest (back) image — % of viewport height
imgMaxScale:  1.0,          // largest (front) image — full-bleed = hero slide 0
outLead:      0.35,         // letters start blurring OUT this long before the images finish
// Nav entrance: a soft BLUR + FADE, no slide (a slide reads as a "pop").
navBlur:      14,           // px blur it resolves from
navDur:       1.0,          // slower than the letters so it arrives gently
navStag:      0.08,         // logo, then hamburger
navLead:      0.2,          // nav starts in this long before the images finish
};
// The intro wordmark is a NATIVE Webflow element, not built by this script:
//   #pulse-intro-logo → .pulse_intro_logo_row → .pulse_intro_letter ×5
// Its centring and SIZE live in Webflow (edit `.pulse_intro_logo_row`'s font-size
// in the Designer — that one value scales the whole wordmark). Nothing here
// measures or scales it, which is why it can no longer drift off-centre.
var HERO_INTRO_LOGO_SELECTOR = '#pulse-intro-logo';
// The live nav logo, one element PER LETTER (.nav_logo → logo_p…logo_e). Used only
// as the glyph SOURCE — each letter slot above is filled from it, so the intro
// wordmark always matches the real logo.
var HERO_LOGO_SELECTOR = '.nav_logo';
// Plays ONCE per real page load (module flag, not sessionStorage — survives
// Barba navs, resets on a hard refresh).
var _heroIntroPlayed = false;
function resolveHeroIntro() {
// ?intro=off disables the intro for THIS SESSION only (clears when the tab
// closes — never a long-lived cookie); ?intro=on re-enables it.
try {
var p = (new URLSearchParams(window.location.search).get('intro') || '').trim();
if (p === 'off') { sessionStorage.setItem('pulse_intro_off', '1'); return 'off'; }
if (p === 'on')  { sessionStorage.removeItem('pulse_intro_off'); }
if (sessionStorage.getItem('pulse_intro_off')) return 'off';
} catch (e) {}
return 'signature';
}
// The hero image URLs, in order, from whichever deck is ACTUALLY ON SCREEN.
// This must match what the slider will hand off to: below the mobile breakpoint the
// .image_desk_tab deck is display:none and .mobile_image is showing a DIFFERENT set
// of images, so preferring desktop here made the intro play desktop art and then
// hand off to mobile art — a visible mismatch. A hidden element has no client
// rects, which is the same test activeHeroDeck() uses.
function heroIntroImages() {
var mob  = document.querySelectorAll('.mobile_image');
var desk = document.querySelectorAll('.image_desk_tab');
var mobVisible  = mob.length  && mob[0].getClientRects().length  > 0;
var deskVisible = desk.length && desk[0].getClientRects().length > 0;
var slides = mobVisible ? mob : (deskVisible ? desk : (desk.length ? desk : mob));
var out = [].map.call(slides, function (s) {
var el = s.querySelector('.u-image') || s;
var url = null, ar = null;
if (el.tagName === 'IMG') {
url = el.currentSrc || el.src;
// Intrinsic ratio, for the aspect-correct intro boxes. Only readable once
// the image has decoded — see the deck-wide fallback below.
if (el.naturalWidth && el.naturalHeight) ar = el.naturalWidth / el.naturalHeight;
} else {
var bg = window.getComputedStyle(el).backgroundImage;
// Quote-aware: filenames contain parens (e.g. "… (X) 2.jpg"), so a plain
// (.*?)\) would truncate at the first ")". Match between the quotes instead.
var m = bg && bg.match(/url\((['"])(.*?)\1\)/);
if (m) url = m[2];
else { m = bg && bg.match(/url\(([^)]*)\)/); url = m ? m[1] : null; }
}
return url ? { url: url, ar: ar } : null;
}).filter(Boolean);
// A deck is one shoot at one ratio, so any slide that HAS decoded speaks for
// the ones that haven't. This matters: only the deck's current slide is
// eager, so on the desktop deck every slide reads naturalWidth 0 at intro
// time. Measured on /: desktop 1920x1080 (all four lazy, none decoded),
// mobile 1080x1920 (all four eager, all decoded).
var known = null;
for (var k = 0; k < out.length; k++) { if (out[k].ar) { known = out[k].ar; break; } }
for (var j = 0; j < out.length; j++) { if (!out[j].ar) out[j].ar = known; }
return out;
}
// Drop the black anti-FOUC cover that pulse-head.html painted before first paint.
// Called the moment the intro overlay exists (the hand-off is invisible — both are
// black), or immediately on any path where the intro won't play, so the cover can
// never linger. Harmless if the head snippet isn't installed.
function releaseIntroHold() {
document.documentElement.classList.remove('pulse-intro-hold');
}
// Play the chosen intro over the hero, then fade the overlay out and call
// onDone() (which starts autoplay). Built on GSAP (already loaded by the engine)
// so the staggers/eases mirror the Figma motion.dev output.
function playHeroIntro(name, onDone) {
var host = document.querySelector('.hero_section');
var images = heroIntroImages();
if (!host || !images.length || name === 'off' || typeof gsap === 'undefined') {
releaseIntroHold(); onDone(); return;
}
// If the page loaded in a HIDDEN/backgrounded tab, requestAnimationFrame is
// throttled, so a GSAP timeline started now may never tick to completion —
// which would leave the overlay covering the site (a white screen) until the
// tab is focused. Don't play an animated intro we can't render; just start
// the slider. (Foreground loads have document.hidden === false and play it.)
if (document.hidden) { releaseIntroHold(); onDone(); return; }
// Hide the site nav while the intro plays; it blurs back in at the end.
// We animate the nav's CHILDREN, never `.nav` itself. Putting opacity or a
// filter on `.nav` makes it a stacking context / backdrop root, which isolates
// the logo's mix-blend-mode: exclusion — the logo composites differently while
// the entrance runs and then visibly SNAPS the moment those props are cleared.
// That snap is the "pop". Animating the children leaves `.nav` untouched.
var nav = document.querySelector('.nav');
var navBits = nav
? Array.prototype.slice.call(nav.querySelectorAll('.nav_logo, .nav_hamburger_wrap'))
: [];
if (!navBits.length && nav) navBits = [nav];   // fallback if the markup differs
if (navBits.length) gsap.set(navBits, { autoAlpha: 0 });
var overlay = document.createElement('div');
overlay.className = 'hero_intro';
overlay.setAttribute('data-intro', name);
// Viewport-FIXED and appended to <body> — NOT absolute inside .hero_section.
// On the live site .hero_section is a 0-height wrapper: its slides are
// position:absolute and size themselves against <body>. If we made
// .hero_section a positioning context (position:relative) or nested an
// inset:0 overlay in it, the overlay AND the hero slides would both collapse
// to 0 height (blank screen — and it would persist, since the hero stays
// collapsed after teardown). A fixed, body-level overlay is immune to
// whatever box the hero section is.
overlay.style.cssText = 'position:fixed;inset:0;z-index:50;overflow:hidden;background:#000;';
document.body.appendChild(overlay);
var D = HERO_INTRO_FAILSAFE;
// Teardown is idempotent and — crucially — GUARANTEED by a wall-clock timer,
// not just GSAP's onComplete. If the timeline ever stalls (tab throttled mid
// load, a GSAP hiccup), the failsafe still removes the overlay so the intro
// can NEVER permanently white-screen the site. onDone (start autoplay) runs
// exactly once.
var _torn = false, _failsafe = null;
function teardown(withFade, fadeDur) {
if (_torn) return; _torn = true;
if (_failsafe) { clearTimeout(_failsafe); _failsafe = null; }
// The wordmark is a real Webflow element, so it is HIDDEN, never removed —
// clearing the props GSAP set on the letters returns it to its authored state
// so a later re-init (Barba back to home) finds it exactly as designed.
var introLogo = document.querySelector(HERO_INTRO_LOGO_SELECTOR);
var hideLogo = function () {
if (!introLogo) return;
gsap.set(introLogo.querySelectorAll('[data-pulse-letter]'), { clearProps: 'all' });
gsap.set(introLogo, { clearProps: 'all' });   // back to the Webflow display:none
};
var kill = function () { if (overlay && overlay.parentNode) overlay.remove(); hideLogo(); };
if (withFade) {
var d = fadeDur != null ? fadeDur : 0.5;
gsap.to([overlay, introLogo].filter(Boolean), { opacity: 0, duration: d, ease: 'power2.inOut', onComplete: kill });
setTimeout(kill, (d + 0.4) * 1000); // remove even if the fade tween itself stalls
} else {
kill();
}
// Make sure the nav ends up visible, then clear every transient prop the intro
// set on it. Clearing the filter matters: a lingering filter (even blur(0px))
// keeps the nav a backdrop root and breaks the logo's mix-blend-mode: exclusion.
if (navBits.length) gsap.to(navBits, { autoAlpha: 1, duration: 0.6, ease: 'power2.out',
onComplete: function () { gsap.set(navBits, { clearProps: 'filter,transform,x,y' }); } });
if (nav) gsap.set(nav, { clearProps: 'zIndex' });
onDone();
}
function done() { teardown(true); }
_failsafe = setTimeout(function () { teardown(false); }, (D + 2) * 1000);
{
// Signature intro — code rebuild of the Jitter timeline (the Lottie was a
// motion reference only, 15-17 MB, not shipped). On black:
//   1) PULSE wordmark: each letter BLUR + SLIDEs in (from the left, →),
//      staggered — the horizontal motion-blur IS the "streak", no rule layer.
//   2) ~7 hero images stacked at increasing scale (~30%→100%); each MASK-CENTER
//      reveals (horizontal band from the centre) + a little zoom, smallest→
//      largest. The last (full-bleed) is hero slide 0 → seamless hand-off.
//   3) Letters BLUR + SLIDE OUT (reverse order, same settings).
//   4) The real nav BLUR + SLIDEs in.
// Tune everything from the SIG config at the top. TS scales the whole timeline.
var portrait = (window.innerWidth || 1440) <= HERO_STACK_BP;
var TS = portrait ? 1.2 : 1.0;
var vw = window.innerWidth  || document.documentElement.clientWidth  || 1440;
var vh = window.innerHeight || document.documentElement.clientHeight || 900;
var n  = images.length;
// ── Images: stacked, increasing scale, each mask-center reveals ──
var imgEls = [];
for (var i = 0; i < n; i++) {
var scale = SIG.imgMinScale + (SIG.imgMaxScale - SIG.imgMinScale) * (n > 1 ? i / (n - 1) : 1);
var slide = (i === n - 1) ? images[0] : images[(i + 1) % n];   // biggest/last = slide 0
var url = slide.url;
// HEIGHT drives the frame; width follows the image's OWN ratio, so nothing
// is cropped. This used to be a hard-coded 16:9 box with the art
// cover-fitted into it — fine for the desktop deck (genuinely 16:9) and
// ruinous for the mobile one (9:16), which lost ~68% of its height to a
// centre-band crop. That was the "mobile crop" the intro was disabled for.
var ar = slide.ar || HERO_INTRO_FALLBACK_AR;
var bw = Math.round(scale * vh * ar), bh = Math.round(scale * vh);
var last = (i === n - 1);
// The hand-off frame is the ONE exception and must stay full-bleed: it has
// to match the live hero slide box exactly or the hero jumps when the
// overlay fades. The hero itself is a cover crop, so this frame crops too.
if (last) { bw = vw; bh = vh; }   // full-bleed = EXACT viewport (matches the hero slide box)
var box = document.createElement('div');
box.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);overflow:hidden;' +
'width:' + bw + 'px;height:' + bh + 'px;z-index:' + (10 + i) + ';clip-path:inset(50% 0% 50% 0%);';
var im = document.createElement('div');
// The last (full-bleed) image is the hand-off frame: it must render the SAME
// crop as the live hero .u-image, which is now oversized for the slingshot
// (height:110%, nudged up 5%). A plain inset:0 cover would crop differently
// and the hero would "jump" on hand-off — so match that geometry exactly.
im.style.cssText = last
? 'position:absolute;left:0;top:-5%;width:100%;height:110%;background:center/cover no-repeat;background-image:url("' + url + '");'
: 'position:absolute;inset:0;background:center/cover no-repeat;background-image:url("' + url + '");';
box.appendChild(im);
overlay.appendChild(box);
imgEls.push({ box: box, im: im });
}
// ── Wordmark: the NATIVE Webflow element (#pulse-intro-logo) ──────────────
// The wordmark is authored in Webflow, not built here:
//   #pulse-intro-logo  .pulse_intro_logo      fixed, inset:0, flex-centred, z-60
//     .pulse_intro_logo_row                   font-size:<n>vw  ← the size knob
//       .pulse_intro_letter ×5                [data-pulse-letter="p|u|l|s|e"]
// Webflow owns the centring and the size (plain flexbox — visible and tweakable
// in the Designer), so there is NOTHING to measure, scale or re-derive here.
// That whole clone-and-measure path is gone, along with every way it could
// drift off-centre. We only fill in the glyphs, show it, and animate.
//
// It sits at z-index 60 vs the overlay's 50, so it renders ABOVE the images
// without being moved into the overlay — the element never leaves its Webflow
// home, so teardown can't destroy it and a Barba re-init always finds it again.
var letters = [];
var logoEl  = document.querySelector(HERO_INTRO_LOGO_SELECTOR);
if (logoEl) {
var slots   = logoEl.querySelectorAll('[data-pulse-letter]');
var srcLogo = HERO_LOGO_SELECTOR ? document.querySelector(HERO_LOGO_SELECTOR) : null;
// Fill each empty slot with the matching glyph cloned from the live nav logo,
// so the wordmark is always in sync with the real logo and there's nothing to
// paste. Slots that already contain artwork (authored in Webflow) are left alone.
if (srcLogo) {
Array.prototype.forEach.call(slots, function (slot, i) {
if (slot.children.length) return;
var srcSvg = srcLogo.children[i] && srcLogo.children[i].querySelector('svg');
if (srcSvg) {
var g = srcSvg.cloneNode(true);
g.removeAttribute('class'); g.removeAttribute('width'); g.removeAttribute('height');
slot.appendChild(g);
}
});
}
gsap.set(logoEl, { display: 'flex' });   // Webflow keeps it display:none at rest
letters = Array.prototype.slice.call(slots);
}
// The letters are already at their final size (Webflow sized them), so the
// slide/blur are the Jitter pixel values directly — no scale compensation.
var Lslide = SIG.letterSlide, Lblur = SIG.letterBlur;
var tl = gsap.timeline({ onComplete: function () { done(); } });
// 1) Letters blur + slide IN (from the left, →), staggered.
gsap.set(letters, { opacity: 0, x: -Lslide, filter: 'blur(' + Lblur + 'px)' });
tl.to(letters, { opacity: 1, x: 0, filter: 'blur(0px)', duration: SIG.letterDur * TS,
ease: SIG.letterEaseIn, stagger: SIG.letterStag * TS }, 0);
// The images wait for the wordmark to FINISH, not merely to have started its
// last letter. lastLetterStart is when the final letter begins; it lands one
// full letterDur later — so the mask begins after that, plus imgStartGap.
var lastLetterStart = (letters.length - 1) * SIG.letterStag * TS;
var lettersDone     = lastLetterStart + SIG.letterDur * TS;
var imgStart        = lettersDone + SIG.imgStartGap * TS;
// 2) Images mask-center IN (+ zoom content), staggered, smallest → full-bleed.
imgEls.forEach(function (o, k) {
var at = imgStart + k * SIG.imgStag * TS;
var imgEase = (typeof pulseEase === 'function') ? pulseEase(SIG.imgEase) : (SIG.imgEase || 'power2.inOut');
tl.fromTo(o.box, { clipPath: 'inset(50% 0% 50% 0%)' },
{ clipPath: 'inset(0% 0% 0% 0%)', duration: SIG.imgDur * TS, ease: imgEase }, at);
tl.fromTo(o.im, { scale: 1 + SIG.imgZoom }, { scale: 1, duration: SIG.imgDur * TS, ease: imgEase }, at);
});
var imgEnd = imgStart + (n - 1) * SIG.imgStag * TS + SIG.imgDur * TS;
// 3) Letters blur + slide OUT (reverse order, same settings) as the images land.
tl.to(letters.slice().reverse(), { opacity: 0, x: Lslide, filter: 'blur(' + Lblur + 'px)',
duration: SIG.letterDur * TS, ease: SIG.letterEaseOut, stagger: SIG.letterStag * TS },
imgEnd - SIG.outLead * TS);
// 4) The real nav BLURS + FADES in — soft, no slide, gently staggered. Raised
//    above the overlay so it reads on top. Note this animates navBits (the nav's
//    children), never `.nav` itself — see the note where navBits is built: a
//    filter/opacity on `.nav` isolates the logo's exclusion blend and makes it
//    snap when cleared. `filter` is set to 'none' at the end rather than
//    blur(0px) for the same reason — blur(0px) still counts as a filter.
if (nav) tl.set(nav, { zIndex: 60 }, imgEnd - SIG.navLead * TS);
if (navBits.length) {
tl.fromTo(navBits,
{ autoAlpha: 0, filter: 'blur(' + SIG.navBlur + 'px)' },
{ autoAlpha: 1, filter: 'blur(0px)', duration: SIG.navDur * TS,
ease: 'power2.out', stagger: SIG.navStag * TS,
onComplete: function () { gsap.set(navBits, { filter: 'none' }); } },
imgEnd - SIG.navLead * TS);
}
tl.call(function () { heroJumpTo(0); }, null, imgEnd);   // live hero on the matching slide beneath
// Everything above is synchronous, so the browser hasn't painted yet: the
// intro's frame 0 is fully staged. Safe to drop the head's black cover now —
// it hands off to the overlay's own black with nothing in between.
releaseIntroHold();
return;
}
}
function buildHeroAutoplay(controller, slideCount, holdSeconds) {
if (!controller || slideCount < 2) return null;
// Loops forever: wait `holdSeconds`, advance, repeat. Mirrors the
// original timeline's "+=2" hold between crossfades.
// Built PAUSED — initHeroSlider decides when to start it: immediately on a
// normal (re)init, or only AFTER the first-load intro reveal finishes so the
// hero "wipes in" before it begins cycling.
var tl = gsap.timeline({ repeat: -1, paused: true });
tl.to({}, {
duration: holdSeconds,
repeat: slideCount - 1,
onRepeat: advance,
onComplete: advance
});
function advance() {
var next = (controller.current + 1) % slideCount;
controller.goTo(next, 'next');
// Deliberately does NOT touch the lean — the slingshot belongs to the user's
// input and only releases when they stop.
}
return tl;
}
var _heroInputTarget       = null;
var _heroWheelHandler      = null;
var _heroTouchStartHandler = null;
var _heroTouchMoveHandler  = null;
var _heroTouchEndHandler   = null;
var _heroWheelAccum   = 0;
// How far you have to push before a slide flips. The deck stacks (HERO_MAX_STACK),
// so crossing these repeatedly starts a new mask over the one still opening rather
// than being dropped — lower them for a livelier, more overlapping deck.
var HERO_WHEEL_COMMIT = 110;   // accumulated wheel delta to flip a slide
var HERO_TOUCH_COMMIT = 40;   // finger px to flip a slide
var HERO_EFFECT = 'pulse';
(function () {
var VALID = { pulse:1, push:1, flip:1, mask:1, bloom:1, sequence:1 };
var pick = null;
try { pick = new URLSearchParams(window.location.search).get('fx'); } catch (e) {}
if (!pick && typeof window.PULSE_HERO_EFFECT === 'string') pick = window.PULSE_HERO_EFFECT;
if (pick && VALID[pick]) { HERO_EFFECT = pick; window.PULSE_FX_PINNED = true; }
})();
var HERO_MASK_FROM = 'center';
var HERO_MASK_MODE = 'in';
var HERO_MASK_SLIDE     = true;
var HERO_MASK_SLIDE_AMT = 20;
var HERO_SEQ_OUT_SCALE = 1.00;
var HERO_IN_SCALE      = 1.25;
var HERO_MASK_OUT      = true;
var HERO_MASK_OUT_DIR  = false;
var HERO_BACKDROP      = '';
var HERO_SCRIM         = false;
var HERO_SCRIM_OPACITY = 0.35;
var HERO_SCRIM_COLOR   = '#000000';
var HERO_OUT_RATIO     = 0.70;
var HERO_IN_DELAY      = 0.45;
var HERO_IN_RATIO      = 1.0;
var HERO_COOLDOWN     = 1.25;
var _heroCooldownUntil = 0;
// The single entry point for INPUT-driven slide changes — both the Observer path
// and the manual fallback go through here, so the cooldown can't be bypassed by
// one of them. Returns false when the gate is still shut.
function heroInputAdvance(deck, dir) {
var now = Date.now();
if (now < _heroCooldownUntil) return false;
_heroCooldownUntil = now + HERO_COOLDOWN * 1000;
heroAdvance(deck, dir);
return true;
}
var HERO_INPUT_MODE      = 'observer';
var HERO_INVERT_SCROLL   = true;   // matches GSAP's demo mapping (wheelSpeed -1)
var HERO_TOUCH_NAV       = true;
var HERO_OBS_TOLERANCE   = 23;
var _heroObserver        = null;
// Observer lives in the ScrollTrigger bundle but isn't always a global.
function heroGetObserver() {
if (typeof window.Observer !== 'undefined') return window.Observer;
try {
var g = gsap.core.globals();
if (g && g.Observer) return g.Observer;
} catch (e) {}
return null;
}
var HERO_WHEEL_GAP     = 90;    // ms of wheel silence that ends a gesture
var HERO_WHEEL_DECAY   = 0.5;   // momentum must fall to this × peak before a rise counts
var HERO_WHEEL_RISE    = 1.3;   // |delta| rising by this × the previous one = a new flick
var HERO_WHEEL_MAXLOCK = 200;  // ms — hard ceiling; the lock can NEVER outlive this
var _heroWheelLocked  = false;
var _heroWheelLockAt  = 0;
var _heroWheelPeak    = 0;     // biggest |delta| seen since the lock closed
var _heroWheelArmed   = false; // momentum has decayed enough that a rise means new input
var _heroWheelLast    = 0;     // previous |delta|, for the rise test
var _heroWheelGapTimer = null;
// Release the gate and start a fresh gesture.
function heroWheelUnlock() {
_heroWheelLocked = false;
_heroWheelAccum  = 0;
_heroWheelPeak   = 0;
_heroWheelArmed  = false;
}
// Per-gesture touch state.
var _heroTouchStartX = 0;
var _heroTouchStartY = 0;
var _heroTouchAxis   = null;  // null (undecided) | 'v' (drives slides) | 'h' (ignored)
var _heroTouchFired  = false; // one slide change per gesture
// ms of no wheel/touch over the hero before autoplay picks back up.
var HERO_IDLE_RESUME = 900;
var _heroIdleTimer = null;
function pauseHeroAutoplay() {
if (heroAutoplayDesktop) heroAutoplayDesktop.pause();
if (heroAutoplayMobile)  heroAutoplayMobile.pause();
}
function resumeHeroAutoplay() {
if (heroAutoplayDesktop) heroAutoplayDesktop.play();
if (heroAutoplayMobile)  heroAutoplayMobile.play();
}
// Called on every hero wheel/touch: pause autoplay now, and (re)arm a timer to
// resume it once the user stops interacting. Replaces the old "pause forever on
// first scroll" behavior — the deck goes back to looping on its own when idle.
function bumpHeroIdle() {
pauseHeroAutoplay();
if (_heroIdleTimer) clearTimeout(_heroIdleTimer);
_heroIdleTimer = setTimeout(function() {
_heroIdleTimer = null;
resumeHeroAutoplay();
}, HERO_IDLE_RESUME);
}
function pulseSyncHeroDecks() {
var deck = activeHeroDeck();
if (!deck) return;
var offSel = deck.sel === '.mobile_image' ? '.image_desk_tab' : '.mobile_image';
document.querySelectorAll(deck.sel).forEach(function (el) { el.classList.remove('pulse-deck-off'); });
document.querySelectorAll(offSel).forEach(function (el) { el.classList.add('pulse-deck-off'); });
}
// <= this width uses the .mobile_image deck. Only consulted when the CSS has no
// opinion — which is the case at/below 767, where Webflow shows BOTH decks
// (`.mobile_image` turns display:block, `.image_desk_tab` is never hidden by the
// stylesheet at any width). Above 767 the stylesheet hides .mobile_image and that
// answer wins before this constant is reached. It was 991, which disagreed with
// the CSS across 768–991 and only stayed harmless because the CSS answered first.
var HERO_MOBILE_DECK_BP = 767;
function heroDeckHidden(sel) {
var el = document.querySelector(sel);
if (!el) return true;
if (el.classList.contains('pulse-deck-off')) return null;   // ours — no opinion
return el.getClientRects().length === 0;
}
// Both wheel and touch drive whichever deck is actually in play.
function activeHeroDeck() {
var deskHidden = heroDeckHidden('.image_desk_tab');
var mobHidden  = heroDeckHidden('.mobile_image');
// Respect the stylesheet when it genuinely hides one of them...
if (mobHidden === true && heroControllerDesktop) {
return { controller: heroControllerDesktop, count: document.querySelectorAll('.image_desk_tab').length, sel: '.image_desk_tab' };
}
if (deskHidden === true && heroControllerMobile) {
return { controller: heroControllerMobile, count: document.querySelectorAll('.mobile_image').length, sel: '.mobile_image' };
}
// ...otherwise decide by viewport, which is stable no matter what we hid.
var wantMobile = window.matchMedia
? window.matchMedia('(max-width:' + HERO_MOBILE_DECK_BP + 'px)').matches
: window.innerWidth <= HERO_MOBILE_DECK_BP;
if (wantMobile && heroControllerMobile) {
return { controller: heroControllerMobile, count: document.querySelectorAll('.mobile_image').length, sel: '.mobile_image' };
}
if (heroControllerDesktop) {
return { controller: heroControllerDesktop, count: document.querySelectorAll('.image_desk_tab').length, sel: '.image_desk_tab' };
}
// Only a mobile deck exists on this page.
if (heroControllerMobile) {
return { controller: heroControllerMobile, count: document.querySelectorAll('.mobile_image').length, sel: '.mobile_image' };
}
return null;
}
// Advance the visible deck by `dir` (+1 next / -1 prev), WRAPPING around so the
// hero loops infinitely in both directions (next past the last slide → first,
// prev before the first → last). Starts the mask and locks the lean to it, so the
// two run as a single synchronised motion.
function heroAdvance(deck, dir) {
var n = deck.count;
var next = ((deck.controller.current + dir) % n + n) % n;
deck.controller.goTo(next, dir > 0 ? 'next' : 'prev');
var other = (deck.controller === heroControllerMobile) ? heroControllerDesktop : heroControllerMobile;
if (other && other !== deck.controller) {
var m = (deck.controller === heroControllerMobile)
? document.querySelectorAll('.image_desk_tab').length
: document.querySelectorAll('.mobile_image').length;
// Same index when the decks are the same length (they are — one crop each);
// otherwise just step it, so an uneven pair still tracks direction.
if (m > 0) {
var target = (m === n) ? next : ((other.current + dir) % m + m) % m;
other.goTo(target, dir > 0 ? 'next' : 'prev');
}
}
heroResetAutoplayTimer();
}
// A manual slide change restarts the autoplay clock. Without this, bumpHeroIdle
// only PAUSES the loop and resumes it mid-count — so if you flipped a slide just
// before the hold elapsed, autoplay would immediately flip another one on top of
// you. Seeking to 0 (paused) means you always get a full HERO_HOLD_SECONDS after
// taking control. pause(0) doesn't fire the timeline's repeat/complete callbacks,
// so it can't trigger a stray advance.
function heroResetAutoplayTimer() {
if (heroAutoplayDesktop) heroAutoplayDesktop.pause(0);
if (heroAutoplayMobile)  heroAutoplayMobile.pause(0);
}
// Wheel (desktop) + touch-swipe (mobile) over the hero cycle the slides — for
// EVERY transition, since this only drives controller.goTo() and never touches
// the fx. The deck loops infinitely (wrap-around), so scroll/swipe over the
// hero is ALWAYS consumed (preventDefault) and never hands scrolling back to
// the page — the hero holds the viewport. Autoplay pauses while you interact
// and resumes ~1s after you stop, so it goes back to looping on its own.
// Listeners live on the hero element itself, so they only fire over the hero.
//
// TRADE-OFF: because it never releases, you can't scroll the PAGE past the hero
// while the pointer/finger is over it (navigate via the menu). If you want an
// escape hatch (e.g. release after one full loop) that's a small tweak.
// Commit a wheel-driven slide change and shut the gate behind it.
function heroWheelFire(deck, dir) {
_heroWheelAccum  = 0;
_heroWheelLocked = true;
_heroWheelLockAt = Date.now();
_heroWheelPeak   = 0;
_heroWheelArmed  = false;
heroInputAdvance(deck, dir);
}
function setupHeroScrollNav() {
if (_heroInputTarget) {
if (_heroWheelHandler)      _heroInputTarget.removeEventListener('wheel', _heroWheelHandler, { passive: false });
if (_heroTouchStartHandler) _heroInputTarget.removeEventListener('touchstart', _heroTouchStartHandler, { passive: true });
if (_heroTouchMoveHandler)  _heroInputTarget.removeEventListener('touchmove', _heroTouchMoveHandler, { passive: false });
if (_heroTouchEndHandler)   _heroInputTarget.removeEventListener('touchend', _heroTouchEndHandler);
}
_heroInputTarget = _heroWheelHandler = _heroTouchStartHandler = _heroTouchMoveHandler = _heroTouchEndHandler = null;
_heroWheelAccum  = 0;
_heroWheelLocked = false;
_heroWheelPeak   = 0;
_heroWheelArmed  = false;
_heroWheelLast   = 0;
_heroTouchAxis   = null;
_heroTouchFired  = false;
if (_heroIdleTimer)      { clearTimeout(_heroIdleTimer);      _heroIdleTimer = null; }
if (_heroWheelGapTimer)  { clearTimeout(_heroWheelGapTimer);  _heroWheelGapTimer = null; }
// Must be the INCOMING hero, not the one leaving with the old container —
// otherwise the Observer binds to an element Barba is about to remove.
var heroSection = pulseLiveHero();
if (!heroSection) return;   // gate class is handled at the top of initHeroSlider
// ── Observer path (default) ──
// One flick = one onUp/onDown, momentum already absorbed by Observer's own
// debounce, so none of the peak/decay/rise bookkeeping below is needed.
if (_heroObserver) { _heroObserver.kill(); _heroObserver = null; }
var Obs = (HERO_INPUT_MODE === 'observer') ? heroGetObserver() : null;
if (Obs) {
_heroObserver = Obs.create({
target: heroSection,
// Touch only when opted in — otherwise the page can't scroll past the hero
// on mobile (see HERO_TOUCH_NAV). Wheel is always captured on desktop.
type: HERO_TOUCH_NAV ? 'wheel,touch' : 'wheel',
tolerance: HERO_OBS_TOLERANCE,
preventDefault: true,       // the hero holds the viewport (wheel; touch only if opted in)
wheelSpeed: HERO_INVERT_SCROLL ? -1 : 1,
onUp: function () {
var deck = activeHeroDeck();
if (deck && deck.count > 1) { bumpHeroIdle(); heroInputAdvance(deck, 1); }
},
onDown: function () {
var deck = activeHeroDeck();
if (deck && deck.count > 1) { bumpHeroIdle(); heroInputAdvance(deck, -1); }
}
});
_heroInputTarget = heroSection;
return;
}
// ── Wheel (mouse / trackpad) ──
_heroWheelHandler = function(e) {
var deck = activeHeroDeck();
if (!deck || deck.count < 2) return;
// Always consume scroll over the hero — the deck loops, so it never hands
// scrolling back to the page. Autoplay pauses now and resumes when idle.
e.preventDefault();
bumpHeroIdle();
var d = e.deltaY, ad = Math.abs(d);   // deltaY > 0 = scroll down = advance
// Silence ends the gesture and re-arms. Re-armed on EVERY event, so the timer
// only ever fires once the wheel has actually gone quiet.
if (_heroWheelGapTimer) clearTimeout(_heroWheelGapTimer);
_heroWheelGapTimer = setTimeout(function () {
heroWheelUnlock(); _heroWheelLast = 0;
}, HERO_WHEEL_GAP);
if (_heroWheelLocked) {
if (Date.now() - _heroWheelLockAt > HERO_WHEEL_MAXLOCK) {
heroWheelUnlock();                      // backstop — never stay stuck
} else {
if (ad > _heroWheelPeak) _heroWheelPeak = ad;
// Momentum decays monotonically; once it's well off the peak, arm the rise test.
if (!_heroWheelArmed && ad < _heroWheelPeak * HERO_WHEEL_DECAY) _heroWheelArmed = true;
var rising = _heroWheelArmed && ad > _heroWheelLast * HERO_WHEEL_RISE && ad >= 4;
_heroWheelLast = ad;
if (!rising) return;
heroWheelUnlock();                      // a deliberate second flick
}
}
_heroWheelLast   = ad;
_heroWheelAccum += d;
// Commit at threshold, then lock until the gesture ends (see above). The deck
// stacks (HERO_MAX_STACK), so a second flick mid-animation starts a new mask
// over the one still opening rather than being dropped.
if (_heroWheelAccum >= HERO_WHEEL_COMMIT)       { heroWheelFire(deck,  1); }
else if (_heroWheelAccum <= -HERO_WHEEL_COMMIT) { heroWheelFire(deck, -1); }
};
// ── Touch (mobile) ── vertical swipe, mapped to match the wheel: swipe UP
// (finger up, content up) = next; swipe DOWN = prev. Horizontal swipes are
// ignored so they don't fight any native gestures.
_heroTouchStartHandler = function(e) {
if (e.touches.length !== 1) { _heroTouchAxis = 'h'; return; } // ignore multi-touch (pinch)
_heroTouchStartX = e.touches[0].clientX;
_heroTouchStartY = e.touches[0].clientY;
_heroTouchAxis   = null;
_heroTouchFired  = false;
};
_heroTouchMoveHandler = function(e) {
// Off by default so the page scrolls past the hero on mobile (see HERO_TOUCH_NAV).
if (!HERO_TOUCH_NAV) return;
if (_heroTouchAxis === 'h' || e.touches.length !== 1) return;
var dx = e.touches[0].clientX - _heroTouchStartX;
var dy = e.touches[0].clientY - _heroTouchStartY;
// Lock the axis once past a small deadzone; commit to page/horizontal if
// the gesture is mostly sideways.
if (_heroTouchAxis === null) {
if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
_heroTouchAxis = Math.abs(dy) >= Math.abs(dx) ? 'v' : 'h';
if (_heroTouchAxis === 'h') return;
}
var deck = activeHeroDeck();
if (!deck || deck.count < 2) return;
// Consume the vertical swipe — the deck loops, so the page never takes over.
// Autoplay pauses now and resumes once the gesture ends and it goes idle.
e.preventDefault();
bumpHeroIdle();
// Commit once per gesture. Finger up (dy < 0) advances (= wheel scroll-down).
if (!_heroTouchFired && Math.abs(dy) > HERO_TOUCH_COMMIT) {
_heroTouchFired = true;
heroInputAdvance(deck, dy < 0 ? 1 : -1);
}
};
_heroTouchEndHandler = function() {
_heroTouchAxis  = null;
_heroTouchFired = false;
};
_heroInputTarget = heroSection;
heroSection.addEventListener('wheel',      _heroWheelHandler,      { passive: false });
// Only bind the touch trio when swipe-nav is actually ON. A non-passive
// touchmove opts the whole hero out of iOS Safari's fast scroll path, and with
// HERO_TOUCH_NAV false the handler returns on its first line — so we were
// paying that cost on every phone for a listener that does nothing.
if (HERO_TOUCH_NAV) {
heroSection.addEventListener('touchstart', _heroTouchStartHandler, { passive: true });
heroSection.addEventListener('touchmove',  _heroTouchMoveHandler,  { passive: false });
heroSection.addEventListener('touchend',   _heroTouchEndHandler);
}
}
// One scrim layer per hero, behind every slide. Created lazily and reused, so
// re-inits (Barba, resize) never stack duplicates.
function heroScrimEl() {
var host = document.querySelector('.hero_section');
if (!host) return null;
var el = host.querySelector('.pulse_hero_scrim');
if (!el) {
el = document.createElement('div');
el.className = 'pulse_hero_scrim';
// z-index 0 keeps it under the slides (which stack from 1 up), so it only
// shows through where a mask has clipped the imagery away.
el.style.cssText = 'position:absolute;inset:0;z-index:0;pointer-events:none;opacity:0;';
host.insertBefore(el, host.firstChild);
}
el.style.background = HERO_SCRIM_COLOR;
// Never leave it opaque when the scrim is disabled — see applyScrimOn.
if (!HERO_SCRIM) el.style.opacity = '0';
return el;
}
window.heroScrimEl = heroScrimEl;
function pulseLiveHero() {
var els = document.querySelectorAll('.hero_section');
for (var i = 0; i < els.length; i++) {
if (!els[i].closest('[data-barba="container"].pulse-leaving')) return els[i];
}
return null;
}
function initHeroSlider() {
document.documentElement.classList.toggle(
'pulse-hero-touch', !!HERO_TOUCH_NAV && !!pulseLiveHero());
if (heroAutoplayDesktop) { heroAutoplayDesktop.kill(); heroAutoplayDesktop = null; }
if (heroAutoplayMobile)  { heroAutoplayMobile.kill();  heroAutoplayMobile  = null; }
heroControllerDesktop = null;
heroControllerMobile  = null;
if (typeof PulseSwap === 'undefined') {
console.warn('[PulseHero] PulseSwap not found — make sure pulse-site-engine.js loads first.');
return;
}
// ── Desktop / tablet ──
var slidesDesktop = document.querySelectorAll(".image_desk_tab");
if (slidesDesktop.length > 0) {
heroControllerDesktop = PulseSwap.createSwapController({
items: slidesDesktop,
inner: [...slidesDesktop].map(function(s) { return s.querySelector(".u-image"); }),
duration: HERO_SWAP_DUR,
currentClass: "is-current",
initialIndex: 0,
effect: HERO_EFFECT,
ease: HERO_SWAP_EASE,
outEase: HERO_SWAP_OUT_EASE,
maskFrom: HERO_MASK_FROM,
maskMode: HERO_MASK_MODE,
maskSlide: HERO_MASK_SLIDE,
maskSlideAmt: HERO_MASK_SLIDE_AMT,
seqOutScale: HERO_SEQ_OUT_SCALE,
inScale: HERO_IN_SCALE,
maskOut: HERO_MASK_OUT,
maskOutDir: HERO_MASK_OUT_DIR,
scrimEl: heroScrimEl(),
scrimOn: HERO_SCRIM,
scrimOpacity: HERO_SCRIM_OPACITY,
outRatio: HERO_OUT_RATIO,
inDelayRatio: HERO_IN_DELAY,
inRatio: HERO_IN_RATIO,
stack: HERO_MAX_STACK,   // bounded overlap — see HERO_MAX_STACK
});
if (heroControllerDesktop && slidesDesktop.length > 1) {
heroAutoplayDesktop = buildHeroAutoplay(heroControllerDesktop, slidesDesktop.length, HERO_HOLD_SECONDS);
}
}
// ── Mobile ──
var slidesMobile = document.querySelectorAll(".mobile_image");
if (slidesMobile.length > 0) {
heroControllerMobile = PulseSwap.createSwapController({
items: slidesMobile,
inner: [...slidesMobile].map(function(s) { return s.querySelector(".u-image"); }),
duration: HERO_SWAP_DUR,
currentClass: "is-current",
initialIndex: 0,
effect: HERO_EFFECT,
ease: HERO_SWAP_EASE,
outEase: HERO_SWAP_OUT_EASE,
maskFrom: HERO_MASK_FROM,
maskMode: HERO_MASK_MODE,
maskSlide: HERO_MASK_SLIDE,
maskSlideAmt: HERO_MASK_SLIDE_AMT,
seqOutScale: HERO_SEQ_OUT_SCALE,
inScale: HERO_IN_SCALE,
maskOut: HERO_MASK_OUT,
maskOutDir: HERO_MASK_OUT_DIR,
scrimEl: heroScrimEl(),
scrimOn: HERO_SCRIM,
scrimOpacity: HERO_SCRIM_OPACITY,
outRatio: HERO_OUT_RATIO,
inDelayRatio: HERO_IN_DELAY,
inRatio: HERO_IN_RATIO,
stack: HERO_MAX_STACK,   // bounded overlap — see HERO_MAX_STACK
});
if (heroControllerMobile && slidesMobile.length > 1) {
heroAutoplayMobile = buildHeroAutoplay(heroControllerMobile, slidesMobile.length, HERO_HOLD_SECONDS);
}
}
// Both controllers exist now — hide whichever deck this breakpoint isn't using,
// BEFORE anything paints or autoplay starts.
pulseSyncHeroDecks();
// Crossing the breakpoint swaps which deck is live, so re-run it then. Bound
// once — initHeroSlider re-runs on every Barba nav back to home. Width-gated via
// the engine's helper so an iOS URL-bar collapse can't trigger it.
if (!window._pulseHeroDeckResizeBound) {
window._pulseHeroDeckResizeBound = true;
if (typeof pulseOnResize === 'function') pulseOnResize(pulseSyncHeroDecks, 200);
else window.addEventListener('resize', pulseSyncHeroDecks);
}
setupHeroScrollNav();
// ── Intro: on the first real load, play the chosen intro OVER the hero, then
// start autoplay once it finishes. Later (re)inits (Barba nav back home) or
// reduced-motion skip straight to cycling. ──
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (_heroIntroPlayed || reduce) {
releaseIntroHold();   // no intro to cover for — drop the head's black cover
startHeroAutoplays();
} else {
_heroIntroPlayed = true;
playHeroIntro(resolveHeroIntro(), startHeroAutoplays);
}
}
window.initHeroSlider = initHeroSlider;
// Replay the signature intro on demand — the motion lab's "Play intro" button,
// so intro tuning (window.SIG) can be previewed without a hard reload. Tears down
// any existing overlay first, then plays and hands back to autoplay.
window.replayHeroIntro = function () {
var ov = document.querySelector('.hero_intro');
if (ov) ov.remove();
var logo = document.querySelector(HERO_INTRO_LOGO_SELECTOR);
if (logo && typeof gsap !== 'undefined') gsap.set(logo.querySelectorAll('[data-pulse-letter]'), { clearProps: 'all' });
_heroIntroPlayed = true;               // keeps the normal autoplay path sane
playHeroIntro('signature', startHeroAutoplays);
};
document.addEventListener("DOMContentLoaded", initHeroSlider);
// Belt-and-braces for the same failure: if the controllers never got built (GSAP
// blocked, PulseSwap missing, an error thrown before initHeroSlider finished),
// nothing ever marks a slide .is-current. Mark the first one so the hero shows a
// real slide instead of the CSS failsafe's stacked fallback. Runs independently of
// GSAP, so it survives exactly the cases that break everything else.
setTimeout(function () {
['.image_desk_tab', '.mobile_image'].forEach(function (sel) {
var slides = document.querySelectorAll(sel);
if (slides.length && !document.querySelector(sel + '.is-current')) {
slides[0].classList.add('is-current');
}
});
}, 4000);
(function(){var s=document.createElement("style");s.textContent="\n.image_desk_tab,\n.mobile_image {\nposition: absolute;\ninset: 0%;\nwidth: 100%;\nheight: 100%;\nopacity: 0;\npointer-events: none;\noverflow: hidden;\n}\n.hero_section {\nmin-height: 100vh;\nmin-height: 100svh;\noverflow: hidden;\n}\nhtml.pulse-hero-touch,\nhtml.pulse-hero-touch body {\noverscroll-behavior-y: none;\n}\nhtml.pulse-hero-touch .hero_section {\ntouch-action: none;\n}\n.image_desk_tab.pulse-deck-off,\n.mobile_image.pulse-deck-off {\ndisplay: none !important;\n}\n.hero_section:not(:has(.is-current)) .image_desk_tab,\n.hero_section:not(:has(.is-current)) .mobile_image {\nopacity: 1;\n}\n.image_desk_tab.is-current,\n.mobile_image.is-current {\nopacity: 1;\npointer-events: auto;\n}\n#pulse-intro-logo svg {\ndisplay: block;\nwidth: auto;\nheight: 1em;\n}\n#pulse-intro-logo [data-pulse-letter=\"s\"] svg,\n#pulse-intro-logo [data-pulse-letter=\"e\"] svg {\nheight: 1.037em;\n}\n.image_desk_tab .u-image,\n.mobile_image .u-image {\nposition: absolute;\ntop: -5%;\nleft: 0;\nwidth: 100%;\nheight: 110%;\nobject-fit: cover;\nwill-change: transform, opacity;\n}\n";document.head.appendChild(s);})();
;
(function () {
if (typeof gsap === 'undefined') {
console.warn('[PulseModal] GSAP not found — load the site engine first.');
return;
}
var OPEN_D  = 0.4;
var CLOSE_D = 0.3;
// ── module-scoped state (survives Barba re-inits, so the once-bound global
//    handlers below always act on the live gallery) ───────────────────────
var modal, stage, listWrap, titleEl, counterEl;
var controller = null;
var layers = [], layerImgs = [], thumbs = [], titles = [];
var projectTitle = '';         // the open card's title — shared by every frame
var requested = 0;             // latest index the user asked for (see select)
var isOpen = false;
var globalKeysBound = false;
var lastFocus = null;
var revealTl = null;           // the in-flight open/close timeline, so a fast
// reopen can kill it instead of racing it
function prefersReduced() {
return window.matchMedia &&
window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
// The modal's inner markup — the script's, not Webflow's. Class names match
// the styles authored on the /image-modal page (.lightbox*), so the published
// stylesheet dresses this exactly as designed. Structure-only nodes
// (.pulse_modal_stage / _layer / _thumb) are script-owned: the mask and the
// zoom must ride different elements (see "WHY THE LAYERS ARE NESTED" above).
var SHELL =
'<div class="lightbox">' +
// .lightbox_img_wrap is YOURS (Designer), .pulse_modal_stage is the hook this
// script needs — same element, so a restructure can't separate them.
'<div class="lightbox_img_wrap pulse_modal_stage"></div>' +
'<div class="lightbox_img_list"></div>' +
'<div class="lightbox_title"><h2 class="label"></h2></div>' +
// A div, not a button, to match the Designer markup its CSS targets — hence
// the explicit role/tabindex and the keydown handler that gives it
// Enter/Space, which a real <button> would have had for free.
'<div class="lightbox_close" data-modal-close role="button" tabindex="0" ' +
'aria-label="Close">' +
'<div class="text-swap_wrap">' +
'<h2 class="label text-swap_sans">Close</h2>' +
'<h2 class="label text-swap_serif">Close</h2>' +
'</div>' +
'</div>' +
'</div>';
function ensureModal() {
var found = document.querySelectorAll('#pulse-modal');
var existing = null;
// Prefer one already parked on <body> — that's ours from a previous init.
for (var i = 0; i < found.length; i++) {
if (found[i].parentElement === document.body) { existing = found[i]; break; }
}
if (!existing && found.length) existing = found[0];
// Duplicate IDs are invalid and make getElementById a coin toss. Keep one.
for (var j = 0; j < found.length; j++) {
if (found[j] !== existing) found[j].parentNode.removeChild(found[j]);
}
if (!existing && !document.querySelector('.portfolio_card')) return false;
modal = existing || document.createElement('div');
if (!existing) {
modal.id = 'pulse-modal';
modal.style.display = 'none';        // no flash before gsap.set hides it
}
// Relocate (or first-place) onto <body>. Cheap and idempotent — a node
// already there is not touched.
if (modal.parentElement !== document.body) document.body.appendChild(modal);
modal.setAttribute('role', 'dialog');
modal.setAttribute('aria-modal', 'true');
if (!modal.getAttribute('aria-label')) modal.setAttribute('aria-label', 'Project images');
if (!modal.hasAttribute('aria-hidden')) modal.setAttribute('aria-hidden', 'true');
// (Re)build the innards if the expected structure isn't there — e.g. a stale
// embed with the old class names, or a fresh empty div. Idempotent after the
// first build: close() clears the stage/list contents but keeps the nodes,
// so this never rewrites (and never drops the once-bound chrome) again.
if (!modal.querySelector('.pulse_modal_stage') ||
!modal.querySelector('.lightbox_img_list')) {
modal.innerHTML = SHELL;
}
return true;
}
function grabRefs() {
// A cached `modal` can be DETACHED — it was destroyed with a Barba container
// before the relocation above existed, or something removed it. Every ref
// below would then be live but pointing into a document fragment nobody can
// see, which looks exactly like "the modal stopped working". Drop it and let
// ensureModal build a fresh one.
if (modal && !document.body.contains(modal)) {
modal = stage = listWrap = titleEl = counterEl = null;
isOpen = false;
document.documentElement.style.overflow = '';   // never strand the scroll lock
}
if (!ensureModal()) return false;
stage      = modal.querySelector('.pulse_modal_stage');
listWrap   = modal.querySelector('.lightbox_img_list');
titleEl    = modal.querySelector('.lightbox_title .label') ||
modal.querySelector('.label');
counterEl  = modal.querySelector('[data-modal-counter]');
return !!(stage && listWrap);
}
var MAX_PROJECT_IMAGES = 20;
function projectImages(card) {
var shots = [];
// `src` is the original upload (full quality) — what the big view wants.
// `currentSrc` is the responsive variant the grid already fetched — what
// the thumbnail wants, because it's guaranteed to be in cache. The manifest
// images never render, so they have no currentSrc; they fall back to src.
function push(img) {
if (!img) return;
var full = img.getAttribute('src') || '';
if (!full) return;                       // unset prop → empty slot, skip
shots.push({ full: full, small: img.currentSrc || full });
}
push(card.querySelector('.portfolio_img'));
Array.prototype.forEach.call(
card.querySelectorAll('.portfolio_card_set img'), push);
return shots.slice(0, MAX_PROJECT_IMAGES);
}
// ── build the gallery ───────────────────────────────────────────────────
// `shots` is one project's images ({full, small}), cover first.
function buildGallery(shots) {
stage.innerHTML = '';
listWrap.innerHTML = '';
layers = []; layerImgs = []; thumbs = []; titles = [];
shots.forEach(function (shot, i) {
var full  = shot.full;
var small = shot.small;
// Every frame belongs to the same project, so they share its title. The
// counter is what tells you where you are inside the set.
titles.push(projectTitle);
// stage layer — wrapper is masked, inner <img> is scaled (never both).
var layer = document.createElement('div');
layer.className = 'pulse_modal_layer';
var big = document.createElement('img');
big.className = 'lightbox_img';        // ← your Webflow styling lands here
big.alt = titles[i] || '';
big.decoding = 'async';
big.dataset.src = full;            // real src assigned lazily
layer.appendChild(big);
stage.appendChild(layer);
layers.push(layer);
layerImgs.push(big);
// thumbnail — a real <button> so the rail is keyboard-navigable. The
// button is the flex child; .lightbox_img_thumb keeps your styling on the <img>.
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'pulse_modal_thumb';
// Every thumb in a project would otherwise announce the same title, so
// the position is what distinguishes them to a screen reader.
btn.setAttribute('aria-label',
(projectTitle ? projectTitle + ', ' : '') +
'image ' + (i + 1) + ' of ' + shots.length);
var t = document.createElement('img');
t.className = 'lightbox_img_thumb';
t.src = small;
t.alt = '';
t.decoding = 'async';
btn.appendChild(t);
btn.addEventListener('click', function () { select(i); });
listWrap.appendChild(btn);
thumbs.push(btn);
});
}
function ensureLoaded(i) {
var img = layerImgs[i];
if (!img) return Promise.resolve();
if (!img.getAttribute('src') && img.dataset.src) img.src = img.dataset.src;
if (img.complete && img.naturalWidth) return Promise.resolve();
if (img.decode) return img.decode().catch(function () {});
return new Promise(function (res) {
img.addEventListener('load',  res, { once: true });
img.addEventListener('error', res, { once: true });
});
}
// Current image plus both neighbours — arrows and swipes are usually ±1.
function preloadAround(i) {
var n = layerImgs.length;
if (!n) return;
ensureLoaded(i);
if (n > 1) {
ensureLoaded((i + 1) % n);
ensureLoaded((i - 1 + n) % n);
}
}
function select(i) {
var n = layerImgs.length;
if (!controller || !n) return;
i = ((i % n) + n) % n;
if (i === requested) return;
requested = i;
setActiveThumb(i);
setTitle(i);
preloadAround(i);
ensureLoaded(i).then(function () {
if (!isOpen || requested !== i || i === controller.current) return;
// Reduced motion: land on the image, skip the mask entirely.
if (prefersReduced()) controller.jumpTo(i);
else controller.goTo(i, i > controller.current ? 'next' : 'prev');
});
}
function step(delta) {
if (layerImgs.length) select(requested + delta);
}
function setActiveThumb(i) {
thumbs.forEach(function (t, idx) {
var on = idx === i;
t.classList.toggle('is-active', on);
t.setAttribute('aria-current', on ? 'true' : 'false');
var img = t.firstElementChild;
if (img) img.classList.toggle('is-active', on);
});
// Keep the active thumb in view — the rail is 43 wide and scrolls.
var btn = thumbs[i];
if (btn && listWrap.scrollWidth > listWrap.clientWidth) {
listWrap.scrollTo({
left: btn.offsetLeft - (listWrap.clientWidth - btn.offsetWidth) / 2,
behavior: prefersReduced() ? 'auto' : 'smooth',
});
}
}
function setTitle(i) {
if (titleEl) titleEl.textContent = titles[i] || '';
if (counterEl) counterEl.textContent = (i + 1) + ' / ' + titles.length;
}
function openFromCard(card) {
var shots = projectImages(card);
if (!shots.length) return;                 // no cover → nothing to show
var heading = card.querySelector('.body_text');
projectTitle = heading ? heading.textContent.trim() : '';
buildGallery(shots);
requested = 0;
var single = shots.length < 2;
if (listWrap) listWrap.style.display = single ? 'none' : '';
setNavVisible(!single);
controller = window.PulseSwap.createSwapController({
items: layers,          // masked
inner: layerImgs,       // scaled
initialIndex: 0,
// Mask the leaving image out as the next one masks in, rather than letting
// the old one sit open underneath and vanish when the timeline ends.
maskOutgoing: true,
});
if (!controller) return;
setActiveThumb(0);
setTitle(0);
preloadAround(0);
open();
}
// Prev/next are optional in the Designer markup, so guard every lookup.
function setNavVisible(on) {
if (!modal) return;
['[data-modal-prev]', '[data-modal-next]'].forEach(function (sel) {
var el = modal.querySelector(sel);
if (el) el.style.display = on ? '' : 'none';
});
}
// Resolve the site's global mask settings (ease/duration) + the 'top' closed
// inset, all from the engine so the modal opens in the same language as the
// rest of the site. Fallbacks keep it working if the modal ever loads alone.
function maskEase()   { return (window.PULSE_MOTION && window.PULSE_MOTION.ease) || 'power2.out'; }
function maskOpenD()  { return (window.PULSE_MOTION && window.PULSE_MOTION.maskDuration != null) ? window.PULSE_MOTION.maskDuration : OPEN_D; }
function maskCloseD() {
var m = window.PULSE_MOTION;
return (m && m.maskDuration != null) ? m.maskDuration * (m.maskCloseRatio || 0.65) : CLOSE_D;
}
var MODAL_MASK_FROM = null;
var MASK_CLOSED_CENTER = 'inset(50% 0% 50% 0%)';   // collapsed to the centre line
var MASK_OPEN          = 'inset(0% 0% 0% 0%)';
function maskFromEdge() {
if (MODAL_MASK_FROM) return MODAL_MASK_FROM;
var m = window.PULSE_MOTION;
return (m && m.image && m.image.from) || 'center';
}
function closedInset() {
return (typeof window.pulseWipeFromInset === 'function')
? window.pulseWipeFromInset(maskFromEdge())
: MASK_CLOSED_CENTER;
}
function contentEls() {
var lb = modal && modal.querySelector('.lightbox');
return lb ? Array.prototype.slice.call(lb.children) : [];
}
function open() {
isOpen = true;
lastFocus = document.activeElement;
document.documentElement.style.overflow = 'hidden';   // lock page scroll
modal.setAttribute('aria-hidden', 'false');
// visibility is flipped HERE, synchronously, rather than left to autoAlpha.
// A visibility:hidden element cannot take focus, and an autoAlpha tween only
// writes visibility on its FIRST TICK — a frame later. Focusing in between
// silently does nothing and the dialog opens with focus still on <body>.
var reduce = prefersReduced();
if (revealTl) { revealTl.kill(); revealTl = null; }
var content = contentEls();
if (reduce) {
// No motion at all: land on the finished state.
gsap.set(modal, { display: 'block', visibility: 'visible', clipPath: 'none', opacity: 1 });
gsap.set(content, { opacity: 1 });
} else {
gsap.set(modal, {
display: 'block', visibility: 'visible', opacity: 1,
});
gsap.set(content, { opacity: 0 });
revealTl = gsap.timeline({
onComplete: function () {
revealTl = null;
// Drop the inset once it has served its purpose. Leaving a clip-path on
// a fixed, full-viewport element makes it a containing block for its
// descendants for no reason.
gsap.set(modal, { clipPath: 'none' });
},
});
revealTl
.fromTo(modal,
{ clipPath: closedInset() },
{ clipPath: MASK_OPEN, duration: maskOpenD(), ease: maskEase() })
.to(content, {
opacity: 1,
duration: maskOpenD() * 0.55,
ease: 'power2.out',
stagger: 0.05,
});
}
var first = modal.querySelector('[data-modal-close]');
if (first) first.focus({ preventScroll: true });
}
function close() {
if (!isOpen) return;
isOpen = false;
document.documentElement.style.overflow = '';
modal.setAttribute('aria-hidden', 'true');
var finish = function () {
gsap.set(modal, { display: 'none', visibility: 'hidden', clipPath: 'none', opacity: 0 });
// Drop the decoded bitmaps — 43 full-size images is real memory.
stage.innerHTML = '';
listWrap.innerHTML = '';
layers = []; layerImgs = []; thumbs = []; titles = [];
controller = null;
};
// Reverse of the open: the interior goes first, then the panel wipes back up
// to the edge it came from. Reduced motion closes instantly.
if (revealTl) { revealTl.kill(); revealTl = null; }
if (prefersReduced()) {
finish();
} else {
revealTl = gsap.timeline({
onComplete: function () { revealTl = null; finish(); },
});
revealTl
.to(contentEls(), { opacity: 0, duration: maskCloseD() * 0.4, ease: 'power2.in' })
// fromTo here too, and for a second reason: the open cleared clipPath to
// `none`, which is not a value you can interpolate an inset out of.
.fromTo(modal,
{ clipPath: MASK_OPEN },
{ clipPath: closedInset(), duration: maskCloseD(), ease: maskEase() });
}
// Send focus back where it came from, or the page loses its place.
if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
lastFocus = null;
}
// Keep Tab inside the dialog while it's open.
function trapFocus(e) {
var f = Array.prototype.filter.call(
modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
function (el) { return !el.disabled && el.offsetParent !== null; }
);
if (!f.length) return;
var first = f[0], last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) {
e.preventDefault(); last.focus();
} else if (!e.shiftKey && document.activeElement === last) {
e.preventDefault(); first.focus();
}
}
// ── init (runs on load AND after every Barba page transition) ────────────
function initImageModal() {
if (!grabRefs()) return;                  // no gallery on this page → no-op
gsap.set(modal, { opacity: 0, visibility: 'hidden', display: 'none', clipPath: 'none' });
// Modal chrome persists across opens → bind once per modal element.
if (!modal.dataset.pulseBound) {
modal.dataset.pulseBound = '1';
modal.addEventListener('click', function (e) {
if (e.target === modal || e.target.classList.contains('lightbox')) close();
});
modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
el.addEventListener('click', close);
// The close is a DIV (to match the Designer markup), so it doesn't get
// Enter/Space activation the way a <button> does. Hand it back.
el.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
e.preventDefault();
close();
}
});
});
var p = modal.querySelector('[data-modal-prev]');
var n = modal.querySelector('[data-modal-next]');
if (p) p.addEventListener('click', function () { step(-1); });
if (n) n.addEventListener('click', function () { step(1); });
var sx = 0;
stage.addEventListener('touchstart', function (e) {
sx = e.changedTouches[0].clientX;
}, { passive: true });
stage.addEventListener('touchend', function (e) {
var dx = e.changedTouches[0].clientX - sx;
if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
}, { passive: true });
}
if (!globalKeysBound) {
globalKeysBound = true;
document.addEventListener('keydown', function (e) {
if (!isOpen) return;
if (e.key === 'Escape') close();
else if (e.key === 'ArrowRight') step(1);
else if (e.key === 'ArrowLeft') step(-1);
else if (e.key === 'Tab') trapFocus(e);
});
}
// Triggers live inside the swapped Barba container → (re)bind each init.
document.querySelectorAll('.portfolio_card').forEach(function (card) {
if (card.dataset.pulseBound) return;
card.dataset.pulseBound = '1';
// The card is a DIV, so it needs the affordances a button gets for free.
card.style.cursor = 'pointer';
if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
if (!card.hasAttribute('role')) card.setAttribute('role', 'button');
card.addEventListener('click', function (e) {
// Defensive: if a link is ever added inside the card, let it win.
if (e.target.closest('a')) return;
openFromCard(card);
});
card.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') {
e.preventDefault();
openFromCard(card);
}
});
});
}
var style = document.createElement('style');
style.textContent = [
'#pulse-modal{position:fixed;inset:0;z-index:9000;display:none;opacity:0;',
'visibility:hidden;overscroll-behavior:contain;background:#fff;}',
'#pulse-modal .lightbox{background:#fff;}',
'#pulse-modal .lightbox{display:flex;flex-direction:column;position:relative;',
'height:100dvh;max-height:100dvh;box-sizing:border-box;}',
':where(#pulse-modal .lightbox){gap:1rem;padding:1rem;}',
'#pulse-modal .pulse_modal_stage{flex:1 1 auto;min-height:0;}',
'#pulse-modal .lightbox_img_list,',
'#pulse-modal .lightbox_title{flex:0 0 auto;min-height:0;}',
'#pulse-modal .pulse_modal_stage{position:relative;display:grid;',
'grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(0,1fr);',
'min-width:0;min-height:0;}',
'#pulse-modal .pulse_modal_layer{grid-area:1/1;display:grid;',
'grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(0,1fr);',
'place-items:center;min-width:0;min-height:0;overflow:hidden;',
'opacity:0;pointer-events:none;}',
'#pulse-modal .pulse_modal_layer.is-current{opacity:1;}',
'#pulse-modal .pulse_modal_layer > .lightbox_img{height:100%;width:100%;',
'max-width:100%;max-height:100%;margin:0 auto;will-change:transform;}',
':where(#pulse-modal .pulse_modal_layer > .lightbox_img){object-fit:contain;}',
'#pulse-modal .lightbox_img_list{display:flex;flex-wrap:nowrap;align-items:center;',
'height:clamp(56px,12vh,120px);',
'overflow-x:auto;overflow-y:hidden;',
'justify-content:flex-start;scroll-behavior:smooth;',
'scrollbar-width:none;-ms-overflow-style:none;',
// Keep the horizontal drag on the rail from chaining into a page scroll or
// an iOS back-swipe, and let it flick properly on touch.
'overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch;}',
'#pulse-modal .lightbox_img_list::-webkit-scrollbar{display:none;}',
':where(#pulse-modal .lightbox_img_list){gap:.5rem;}',
'#pulse-modal .pulse_modal_thumb{flex:0 0 auto;height:100%;padding:0;',
'border:0;background:none;font:inherit;color:inherit;}',
':where(#pulse-modal .pulse_modal_thumb){cursor:pointer;opacity:.45;',
'transition:opacity .25s ease;}',
':where(#pulse-modal .pulse_modal_thumb.is-active){opacity:1;}',
':where(#pulse-modal .pulse_modal_close){position:absolute;top:1rem;right:1rem;',
'z-index:2;cursor:pointer;}',
'#pulse-modal .lightbox_close{z-index:2;cursor:pointer;}',
'#pulse-modal .lightbox_close .text-swap_wrap{position:relative;display:grid;',
'grid-template-columns:1fr;grid-template-rows:1fr;place-items:stretch;',
'height:1.75rem;overflow:hidden;padding:0 .35em;}',
'#pulse-modal .lightbox_close .text-swap_sans,',
'#pulse-modal .lightbox_close .text-swap_serif{grid-area:1/1;position:relative;',
'height:100%;display:flex;align-items:center;justify-content:center;',
'white-space:nowrap;',
'transition:transform .45s cubic-bezier(.65,0,.35,1);}',
'#pulse-modal .lightbox_close .text-swap_serif{transform:translateY(100%);}',
'#pulse-modal .lightbox_close:hover .text-swap_sans{transform:translateY(-100%);}',
'#pulse-modal .lightbox_close:hover .text-swap_serif{transform:translateY(0);}',
'@media (prefers-reduced-motion: reduce){',
'#pulse-modal .lightbox_close .text-swap_sans,',
'#pulse-modal .lightbox_close .text-swap_serif{transition:none;}}',
'@media (max-width:767px){',
':where(#pulse-modal .lightbox){gap:.6rem;padding:.75rem;}',
// Give the hero the majority of a small screen.
'#pulse-modal .lightbox_img_list{height:clamp(48px,9vh,72px);}',
':where(#pulse-modal .lightbox_close){min-width:44px;min-height:44px;',
'display:flex;align-items:center;justify-content:center;}',
'}',
'@media (max-height:520px) and (orientation:landscape){',
':where(#pulse-modal .lightbox){gap:.4rem;padding:.5rem;}',
'#pulse-modal .lightbox_img_list{height:clamp(40px,14vh,64px);}',
'}',
].join('');
document.head.appendChild(style);
window.initImageModal = initImageModal;
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initImageModal, { once: true });
} else {
initImageModal();
}
if (window.barba && barba.hooks) {
barba.hooks.afterEnter(function () { initImageModal(); });
}
})();
;
